import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { getAgents } from '../../services/agentService';
import { getPersonas } from '../../services/personaService';
import { getKnowledgeBaseByPagination } from '../../services/knowledgeBaseService';
import { getPrompts } from '../../services/promptService';
import { faEnvelope, faHourglass, faObjectUngroup, faUser } from '@fortawesome/free-regular-svg-icons';
import { faCalendarTimes, faChartDiagram, faCircleStop, faCode, faDiagramPredecessor, faDiamond, faLandmark, faPaperPlane, faPlay, faPlayCircle, faPlug, faProjectDiagram, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getModels } from '../../services/modelHubService';
import PythonCodeEditor from './PythonCodeEditor';
import { Button } from '../../styles/PageStyles';
import Modal from '../modals/Modal';
import { MultiSelectDropdownSearch } from '../common/MultiSelectSearch';
import { fetchMCPServer } from '../../services/MCPService';
import { evaluateNodeExpression, getNodeConfig, getNodesForPipeline, getWorkStreams } from '../../services/pipelineService';
import { fetchCountByFilter, getEntitiesByPagination } from '../../services/entityService';
import { getAllEntitiesByFilter } from '../../services/entityService_V2';
import { getPlanners } from '../../services/plannerService';
import { FaTrash } from 'react-icons/fa';
import { getVisibleFields } from '../../utils/commonUtils';
import { DynamicField } from '../common/DynamicField';
import { fetchUsers } from '../../services/authService';
import { mandatoryFields } from '../../constants/nodeDefaults';
import { getTemplateCodes } from '../../services/emailService';
// import { getTemplateCodes } from '../../services/emailService';
import { fetchUsersGropus } from '../../services/groupService';

const PanelContainer = styled.div`
  width: 100%;
  background: white;
  border-left: 1px solid #e0e0e0;
  padding: 1rem;
  overflow-y: auto;
`;

const PanelTitle = styled.h3`
  font-size: 1rem;
  margin-bottom: 1rem;
  color: var(--text-primary);
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f0f0f0;
`;

const NoSelection = styled.div`
  color: var(--text-secondary);
  font-size: 0.9rem;
  text-align: center;
  margin-top: 2rem;
`;

const FormGroup = styled.div`
  margin-bottom: 0.5rem;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  margin-bottom: 0.1rem;
  color: var(--text-secondary);
`;

const Input = styled.input`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 0.9rem;
  
  &:focus {
    outline: none;
    border-color: var(--primary);
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 0.9rem;
  min-height: 80px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: var(--primary);
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 0.9rem;
  background: white;
  
  &:focus {
    outline: none;
    border-color: var(--primary);
  }
`;

const NodeTypeIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => props.background || '#f0f0f0'};
  color: ${props => props.color || 'var(--text-primary)'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin-right: 1rem;
`;

const NodeHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
`;

const NodeInfo = styled.div`
  flex: 1;
`;


const NodeName = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  color: var(--text-primary);
`;

const SectionTitle = styled.h4`
  font-size: 0.9rem;
  margin: 1.5rem 0 0.8rem;
  color: var(--text-secondary);
  padding-bottom: 0.3rem;
  border-bottom: 1px solid #f5f5f5;
`;

const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

const Tag = styled.div`
  background: #f0f0f0;
  border-radius: 4px;
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;
`;

const AddTagButton = styled.button`
  background: transparent;
  border: 1px dashed #ccc;
  border-radius: 4px;
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  
  &:hover {
    background: #f5f5f5;
  }
`;

const RemoveTag = styled.span`
  cursor: pointer;
  font-size: 0.7rem;
  
  &:hover {
    color: #ff3b30;
  }
`;

const PipelineSection = styled.div`
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
`;

const TrashSection = styled.span`
  padding: 0 12px;
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    color: #9ba6b5;
    transition: color 0.2s ease;
  }

  &:hover svg {
    color: #7f8ca0;
  }
`;
let cachedFileNodeConfig = null;
let cachedTimerNodeConfig = null;
let cachedTaskNodeConfig = null;

const FileNodeConfig = ({ selectedNode, handleInputChange }) => {
  const [formValues, setFormValues] = useState(selectedNode.data.data || {});
  const [configData, setConfigData] = useState([]);

  useEffect(() => {
    const fetchFileNodeConfig = async () => {
      if (cachedFileNodeConfig) {
        setConfigData(cachedFileNodeConfig);
        return;
      }

      const resp = await getNodeConfig('file_input');
      const attrs = resp['attributes'] || [];
      cachedFileNodeConfig = attrs; 
      setConfigData(attrs);
    };

    fetchFileNodeConfig();
  }, []);

  


  const handleChange = (name, value) => {
    setFormValues((prev) => {
      let updated = { ...prev, [name]: value };

      const changedField = configData.find(f => f.name === name);

      if (changedField) {
        const childFields = configData.filter(f => f.parent_key === name);

        childFields.forEach((child) => {
          const isValid = child.parent_value?.includes(value);
          if (!isValid && updated.hasOwnProperty(child.name)) {
            delete updated[child.name];
          }
        });
      }

      handleInputChange(`data.${name}`, value);
      return updated;
    });
  };

  const visibleFields = getVisibleFields(configData, formValues);

  return (
    <>
      {visibleFields.map(field => (
        <DynamicField
          key={field.name}
          field={field}
          value={formValues[field.name]}
          onChange={handleChange}
        />
      ))}
    </>
  );
};

const ManualTaskNodeConfig = ({ selectedNode, handleInputChange }) => {
  const nodeData = selectedNode?.data?.data || {};

  const [entityConfigs, setEntityConfigs] = useState([]);
  const [isLoadingEntities, setIsLoadingEntities] = useState(false);
  const [coPilotPlannerCd, setCoPilotPlannerCd] = useState(nodeData.co_pilot_agent?.planner_cd || 'CoPilot');
  const [planners, setPlanners] = useState([]);
  const [isLoadingPlanners, setIsLoadingPlanners] = useState(false);

  useEffect(() => {
    const fetchEntities = async () => {
      try {
        setIsLoadingEntities(true);
        const filters = { type: 'entity' };
        const sort = {};
        const query = 'skip=0&limit=200';
        const response = await getAllEntitiesByFilter(filters, sort, query);
        setEntityConfigs(response || []);
      } catch (error) {
        console.error('Error fetching entity configs for manual_task node:', error);
      } finally {
        setIsLoadingEntities(false);
      }
    };

    fetchEntities();
  }, []);

  useEffect(() => {
    const fetchPlanners = async () => {
      try {
        setIsLoadingPlanners(true);
        const filter = {};
        const sort = {};
        const query = { skip: 0, limit: 200 };
        const response = await getPlanners(filter, sort, query);
        setPlanners(response || []);
      } catch (error) {
        console.error('Error fetching planners for manual_task node copilot:', error);
      } finally {
        setIsLoadingPlanners(false);
      }
    };

    fetchPlanners();
  }, []);

  const aiPanel = nodeData.ai_intelligence_panel || {
    title: '',
    sub_title: '',
    description: '',
    entities: [],
  };

  const aiEntities = aiPanel.entities || [];
  const inDetailEntities = nodeData.in_detail_entities || [];

  const coPilotAgent = nodeData.co_pilot_agent || {};
  const summaryCodeBlock = coPilotAgent.summary_code_block || {
    lang: 'python',
    code_block: '',
  };
  const inDetailSummaryCodeBlock = coPilotAgent.in_detail_summary_code_block || {
    lang: 'python',
    code_block: '',
  };

  const handleBasicChange = (path, value) => {
    handleInputChange(path, value);
  };

  const updateCoPilotAgent = (patch) => {
    const current = nodeData.co_pilot_agent || {};
    const next = {
      ...current,
      ...patch,
      summary_code_block: patch.summary_code_block || current.summary_code_block || {
        lang: 'python',
        code_block: '',
      },
      in_detail_summary_code_block:
        patch.in_detail_summary_code_block ||
        current.in_detail_summary_code_block || {
          lang: 'python',
          code_block: '',
        },
    };

    handleInputChange('data.co_pilot_agent', next);
  };

  const handleCoPilotPlannerChange = (value) => {
    setCoPilotPlannerCd(value);
    updateCoPilotAgent({
      planner_cd: value || 'CoPilot',
    });
  };

  const handleCoPilotSummaryChange = (code) => {
    const currentBlock = nodeData.co_pilot_agent?.summary_code_block || summaryCodeBlock;
    updateCoPilotAgent({
      summary_code_block: {
        ...currentBlock,
        lang: currentBlock.lang || 'python',
        code_block: code || '',
      },
    });
  };

  const handleCoPilotInDetailSummaryChange = (code) => {
    const currentBlock = nodeData.co_pilot_agent?.in_detail_summary_code_block || inDetailSummaryCodeBlock;
    updateCoPilotAgent({
      in_detail_summary_code_block: {
        ...currentBlock,
        lang: currentBlock.lang || 'python',
        code_block: code || '',
      },
    });
  };

  const handleAiPanelFieldChange = (field, value) => {
    const updated = {
      ...aiPanel,
      [field]: value,
    };
    handleInputChange('data.ai_intelligence_panel', updated);
  };

  const handleAiEntityChange = (index, field, value) => {
    const updatedEntities = [...aiEntities];
    updatedEntities[index] = {
      ...(updatedEntities[index] || {}),
      [field]: value,
    };
    const updatedPanel = {
      ...aiPanel,
      entities: updatedEntities,
    };
    handleInputChange('data.ai_intelligence_panel', updatedPanel);
  };


  const handleAiRecomandataonEntityChange = (value) => {
  handleInputChange(
    'data.ai_recommendation',
    {
      ...nodeData.ai_recommendation,
      entity_cd: value,
    }
  );
};


  const handleAiRecomandationCodeblockChange = (value) => {
  handleInputChange(
    'data.ai_recommendation',
    {
      ...nodeData.ai_recommendation,
      id_code_block: {
        ...(nodeData.ai_recommendation?.id_code_block || {}),
        lang: 'python',
        code_block: value,
      },
    }
  );
};

  const handleAiEntityIdCodeChange = (index, code) => {
    const updatedEntities = [...aiEntities];
    const current = updatedEntities[index] || {};
    const currentIdBlock = current.id_code_block || { lang: 'python', code_block: '' };
    updatedEntities[index] = {
      ...current,
      id_code_block: {
        ...currentIdBlock,
        lang: currentIdBlock.lang || 'python',
        code_block: code || '',
      },
    };
    const updatedPanel = {
      ...aiPanel,
      entities: updatedEntities,
    };
    handleInputChange('data.ai_intelligence_panel', updatedPanel);
  };

  const handleAddAiEntity = () => {
    const updatedEntities = [
      ...aiEntities,
      {
        order: null,
        entity_cd: '',
        id_code_block: { lang: 'python', code_block: '' },
      },
    ];
    const updatedPanel = {
      ...aiPanel,
      entities: updatedEntities,
    };
    handleInputChange('data.ai_intelligence_panel', updatedPanel);
  };

  const handleRemoveAiEntity = (index) => {
    const updatedEntities = aiEntities.filter((_, i) => i !== index);
    const updatedPanel = {
      ...aiPanel,
      entities: updatedEntities,
    };
    handleInputChange('data.ai_intelligence_panel', updatedPanel);
  };

  const handleInDetailEntityChange = (index, field, value) => {
    const updatedEntities = [...inDetailEntities];
    updatedEntities[index] = {
      ...(updatedEntities[index] || {}),
      [field]: value,
    };
    handleInputChange('data.in_detail_entities', updatedEntities);
  };

  const handleInDetailEntityIdCodeChange = (index, code) => {
    const updatedEntities = [...inDetailEntities];
    const current = updatedEntities[index] || {};
    const currentIdBlock = current.id_code_block || { lang: 'python', code_block: '' };
    updatedEntities[index] = {
      ...current,
      id_code_block: {
        ...currentIdBlock,
        lang: currentIdBlock.lang || 'python',
        code_block: code || '',
      },
    };
    handleInputChange('data.in_detail_entities', updatedEntities);
  };

  const handleAddInDetailEntity = () => {
    const updatedEntities = [
      ...inDetailEntities,
      {
        order: null,
        entity_cd: '',
        id_code_block: { lang: 'python', code_block: '' },
      },
    ];
    handleInputChange('data.in_detail_entities', updatedEntities);
  };

  const handleRemoveInDetailEntity = (index) => {
    const updatedEntities = inDetailEntities.filter((_, i) => i !== index);
    handleInputChange('data.in_detail_entities', updatedEntities);
  };

  const errorCodeBlock = nodeData.error_code_block || { lang: 'python', code_block: '' };

  const handleErrorCodeChange = (code) => {
    handleInputChange('data.error_code_block', {
      lang: errorCodeBlock.lang || 'python',
      code_block: code || '',
    });
  };

  const assignment = nodeData.assignment || {
    algorithm: 'round_robin',
    target_type: 'group',
    user_email: null,
    group_cd: null,
    candidate_user_emails: [],
    priority: 'medium',
    sla_minutes: null,
    due_at: null,
    required_skills: [],
    min_skill_score: null,
    rules_code_block: null,
    ruleset_cd: null,
    ai_policy_cd: null,
    ai_features: {},
    dynamic_code_block: null,
  };

  const updateAssignmentField = (field, value) => {
    const updated = {
      ...assignment,
      [field]: value,
    };
    handleInputChange('data.assignment', updated);
  };

  const rulesCodeBlock = assignment.rules_code_block || { lang: 'python', code_block: '' };
  const dynamicCodeBlock = assignment.dynamic_code_block || { lang: 'python', code_block: '' };

  const handleRulesCodeChange = (code) => {
    const updated = {
      ...assignment,
      rules_code_block: {
        ...rulesCodeBlock,
        lang: rulesCodeBlock.lang || 'python',
        code_block: code || '',
      },
    };
    handleInputChange('data.assignment', updated);
  };

  const handleDynamicCodeChange = (code) => {
    const updated = {
      ...assignment,
      dynamic_code_block: {
        ...dynamicCodeBlock,
        lang: dynamicCodeBlock.lang || 'python',
        code_block: code || '',
      },
    };
    handleInputChange('data.assignment', updated);
  };

  const assignmentSummary = (() => {
    const algo = assignment.algorithm || 'round_robin';
    const targetType = assignment.target_type || 'group';
    const priority = assignment.priority || 'medium';
    return `${algo} / ${targetType} / ${priority}`;
  })();

  return (
    <>
      <SectionTitle>Manual Task</SectionTitle>

      <FormGroup>
        <Label htmlFor="manual-instructions">Instructions</Label>
        <Textarea
          id="manual-instructions"
          value={nodeData.instructions || ''}
          onChange={(e) => handleBasicChange('data.instructions', e.target.value)}
          placeholder="Describe what the human reviewer should do"
        />
      </FormGroup>

      <FormGroup>
        <Label>Error Code (Python)</Label>
        <PythonCodeEditor
          value={errorCodeBlock.code_block || ''}
          onChange={handleErrorCodeChange}
        />
      </FormGroup>

      <SectionTitle>AI Intelligence Panel</SectionTitle>

      <FormGroup>
        <Label htmlFor="ai-panel-title">Title</Label>
        <Input
          id="ai-panel-title"
          value={aiPanel.title || ''}
          onChange={(e) => handleAiPanelFieldChange('title', e.target.value)}
        />
      </FormGroup>

      <FormGroup>
        <Label htmlFor="ai-panel-sub-title">Sub Title</Label>
        <Input
          id="ai-panel-sub-title"
          value={aiPanel.sub_title || ''}
          onChange={(e) => handleAiPanelFieldChange('sub_title', e.target.value)}
        />
      </FormGroup>

      <FormGroup>
        <Label htmlFor="ai-panel-description">Description</Label>
        <Textarea
          id="ai-panel-description"
          value={aiPanel.description || ''}
          onChange={(e) => handleAiPanelFieldChange('description', e.target.value)}
        />
      </FormGroup>

      {aiEntities.map((ent, index) => (
        <div key={index} style={{ border: '1px solid #eee', padding: '0.5rem', borderRadius: 4, marginBottom: '0.5rem' }}>
          <FormGroup>
            <Label htmlFor={`ai-entity-cd-${index}`}>Entity Code</Label>
            <Select
              id={`ai-entity-cd-${index}`}
              value={ent.entity_cd || ''}
              onChange={(e) => handleAiEntityChange(index, 'entity_cd', e.target.value)}
              disabled={isLoadingEntities}
            >
              <option value="">{isLoadingEntities ? 'Loading entities...' : 'Select entity'}</option>
              {entityConfigs?.map((cfg) => (
                <option key={cfg.id} value={cfg.code}>
                  {cfg.name} ({cfg.code})
                </option>
              ))}
            </Select>
          </FormGroup>

          <FormGroup>
            <Label htmlFor={`ai-entity-order-${index}`}>Order</Label>
            <Input
              id={`ai-entity-order-${index}`}
              type="number"
              value={ent.order ?? ''}
              onChange={(e) => handleAiEntityChange(index, 'order', e.target.value === '' ? null : Number(e.target.value))}
            />
          </FormGroup>

          <FormGroup>
            <Label>Entity Id Code (Python)</Label>
            <PythonCodeEditor
              value={ent.id_code_block?.code_block || ''}
              onChange={(code) => handleAiEntityIdCodeChange(index, code)}
            />
          </FormGroup>

          <Button type="button" onClick={() => handleRemoveAiEntity(index)} style={{ marginTop: '0.25rem' }}>
            Remove
          </Button>
        </div>
      ))}

      <Button type="button" onClick={handleAddAiEntity}>
        Add AI Entity
      </Button>


      <SectionTitle>AI Recomandation</SectionTitle>
        <div
          style={{ border: '1px solid #eee', padding: '0.5rem', borderRadius: 4, marginBottom: '0.5rem' }}
        >
          <FormGroup>
            <Label htmlFor={`ai-recomandation-entity-cd`}>Entity Code</Label>
            <Select
              value={nodeData?.ai_recommendation?.entity_cd || ''}
              onChange={(e) => handleAiRecomandataonEntityChange(e.target.value)}
              disabled={isLoadingEntities}
            >
              <option value="">{isLoadingEntities ? 'Loading entities...' : 'Select entity'}</option>
              {entityConfigs?.map((cfg) => (
                <option key={cfg.id} value={cfg.code}>
                  {cfg.name} ({cfg.code})
                </option>
              ))}
            </Select>
          </FormGroup>

          {/* <FormGroup>
            <Label htmlFor={`in-detail-entity-order-${index}`}>Order</Label>
            <Input
              id={`in-detail-entity-order-${index}`}
              type="number"
              value={ent.order ?? ''}
              onChange={(e) =>
                handleInDetailEntityChange(
                  index,
                  'order',
                  e.target.value === '' ? null : Number(e.target.value),
                )
              }
            />
          </FormGroup> */}

          <FormGroup>
            <Label>Entity Id Code (Python)</Label>
            <PythonCodeEditor
              value={nodeData?.ai_recommendation?.id_code_block?.code_block || ''}
              onChange={(code) => handleAiRecomandationCodeblockChange(code)}
            />
          </FormGroup>
        </div>


      <SectionTitle>In-Detail Entities</SectionTitle>
      {inDetailEntities.length === 0 && (
        <div style={{ marginBottom: '0.5rem', color: '#6b7280', fontSize: '0.85rem' }}>
          No in-detail entities configured yet.
        </div>
      )}

      {inDetailEntities.map((ent, index) => (
        <div
          key={index}
          style={{ border: '1px solid #eee', padding: '0.5rem', borderRadius: 4, marginBottom: '0.5rem' }}
        >
          <FormGroup>
            <Label htmlFor={`in-detail-entity-cd-${index}`}>Entity Code</Label>
            <Select
              id={`in-detail-entity-cd-${index}`}
              value={ent.entity_cd || ''}
              onChange={(e) => handleInDetailEntityChange(index, 'entity_cd', e.target.value)}
              disabled={isLoadingEntities}
            >
              <option value="">{isLoadingEntities ? 'Loading entities...' : 'Select entity'}</option>
              {entityConfigs?.map((cfg) => (
                <option key={cfg.id} value={cfg.code}>
                  {cfg.name} ({cfg.code})
                </option>
              ))}
            </Select>
          </FormGroup>

          <FormGroup>
            <Label htmlFor={`in-detail-entity-order-${index}`}>Order</Label>
            <Input
              id={`in-detail-entity-order-${index}`}
              type="number"
              value={ent.order ?? ''}
              onChange={(e) =>
                handleInDetailEntityChange(
                  index,
                  'order',
                  e.target.value === '' ? null : Number(e.target.value),
                )
              }
            />
          </FormGroup>

          <FormGroup>
            <Label>Entity Id Code (Python)</Label>
            <PythonCodeEditor
              value={ent.id_code_block?.code_block || ''}
              onChange={(code) => handleInDetailEntityIdCodeChange(index, code)}
            />
          </FormGroup>

          <Button
            type="button"
            onClick={() => handleRemoveInDetailEntity(index)}
            style={{ marginTop: '0.25rem' }}
          >
            Remove
          </Button>
        </div>
      ))}

      <Button type="button" onClick={handleAddInDetailEntity}>
        Add In-Detail Entity
      </Button>

      <SectionTitle>Copilot</SectionTitle>
      <FormGroup>
        <Label htmlFor="copilot-planner">Copilot</Label>
        <Select
          id="copilot-planner"
          value={coPilotPlannerCd}
          onChange={(e) => handleCoPilotPlannerChange(e.target.value)}
          disabled={isLoadingPlanners}
        >
          <option value="">{isLoadingPlanners ? 'Loading planners...' : 'Select planner'}</option>
          {planners?.map((planner) => (
            <option key={planner.id || planner.code} value={planner.code}>
              {planner.name} ({planner.code})
            </option>
          ))}
        </Select>
      </FormGroup>

      <FormGroup>
        <Label>Summary Code (Python)</Label>
        <PythonCodeEditor
          value={summaryCodeBlock.code_block || ''}
          onChange={handleCoPilotSummaryChange}
        />
      </FormGroup>

      <FormGroup>
        <Label>In-Detail Summary Code (Python)</Label>
        <PythonCodeEditor
          value={inDetailSummaryCodeBlock.code_block || ''}
          onChange={handleCoPilotInDetailSummaryChange}
        />
      </FormGroup>

      <SectionTitle>Assignment</SectionTitle>
      <FormGroup>
        <Label>Assignment Summary</Label>
        <Input value={assignmentSummary} readOnly />
      </FormGroup>

      <FormGroup>
        <Label htmlFor="assign-algorithm">Algorithm</Label>
        <Select
          id="assign-algorithm"
          value={assignment.algorithm || 'round_robin'}
          onChange={(e) => updateAssignmentField('algorithm', e.target.value)}
        >
          <option value="round_robin">Round robin</option>
          <option value="direct">Direct</option>
          <option value="least_loaded">Least loaded</option>
          <option value="skill_based">Skill based</option>
          <option value="priority_sla">Priority / SLA</option>
          <option value="rule_based">Rule based</option>
          <option value="ai_smart">AI smart</option>
          <option value="dynamic">Dynamic</option>
        </Select>
      </FormGroup>

      <FormGroup>
        <Label htmlFor="assign-target-type">Target Type</Label>
        <Select
          id="assign-target-type"
          value={assignment.target_type || 'group'}
          onChange={(e) => updateAssignmentField('target_type', e.target.value)}
        >
          <option value="user">User</option>
          <option value="group">Group</option>
        </Select>
      </FormGroup>

      <FormGroup>
        <Label htmlFor="assign-priority">Priority</Label>
        <Select
          id="assign-priority"
          value={assignment.priority || 'medium'}
          onChange={(e) => updateAssignmentField('priority', e.target.value)}
        >
          <option value="low">Low</option>
          <option value="medium">Medium</option>
          <option value="high">High</option>
        </Select>
      </FormGroup>

      <FormGroup>
        <Label htmlFor="assign-user-email">User Email</Label>
        <Input
          id="assign-user-email"
          value={assignment.user_email || ''}
          onChange={(e) => updateAssignmentField('user_email', e.target.value || null)}
          placeholder="user@example.com"
        />
      </FormGroup>

      <FormGroup>
        <Label htmlFor="assign-group-cd">Group Code</Label>
        <Input
          id="assign-group-cd"
          value={assignment.group_cd || ''}
          onChange={(e) => updateAssignmentField('group_cd', e.target.value || null)}
          placeholder="e.g. CLAIM_ASSESSORS"
        />
      </FormGroup>

      <FormGroup>
        <Label htmlFor="assign-sla-minutes">SLA (minutes)</Label>
        <Input
          id="assign-sla-minutes"
          type="number"
          value={assignment.sla_minutes ?? ''}
          onChange={(e) => updateAssignmentField('sla_minutes', e.target.value === '' ? null : Number(e.target.value))}
        />
      </FormGroup>

      <FormGroup>
        <Label htmlFor="assign-due-at">Due At (ISO datetime)</Label>
        <Input
          id="assign-due-at"
          value={assignment.due_at || ''}
          onChange={(e) => updateAssignmentField('due_at', e.target.value || null)}
          placeholder="e.g. 2025-11-10T07:14:06.446922"
        />
      </FormGroup>

      <FormGroup>
        <Label htmlFor="assign-candidates">Candidate User Emails (comma-separated)</Label>
        <Textarea
          id="assign-candidates"
          value={(assignment.candidate_user_emails || []).join(', ')}
          onChange={(e) => {
            const list = e.target.value
              .split(',')
              .map((s) => s.trim())
              .filter(Boolean);
            updateAssignmentField('candidate_user_emails', list.length ? list : []);
          }}
        />
      </FormGroup>

      <FormGroup>
        <Label htmlFor="assign-required-skills">Required Skills (comma-separated)</Label>
        <Textarea
          id="assign-required-skills"
          value={(assignment.required_skills || []).join(', ')}
          onChange={(e) => {
            const list = e.target.value
              .split(',')
              .map((s) => s.trim())
              .filter(Boolean);
            updateAssignmentField('required_skills', list.length ? list : []);
          }}
        />
      </FormGroup>
      {assignment.algorithm === 'skill_based' && (
        <FormGroup>
          <Label htmlFor="assign-min-skill-score">Min Skill Score</Label>
          <Input
            id="assign-min-skill-score"
            type="number"
            step="0.01"
            value={assignment.min_skill_score ?? ''}
            onChange={(e) => updateAssignmentField('min_skill_score', e.target.value === '' ? null : Number(e.target.value))}
          />
        </FormGroup>
      )}

      {assignment.algorithm === 'rule_based' && (
        <>
          <FormGroup>
            <Label>Rules Code (Python, for rule_based)</Label>
            <PythonCodeEditor
              value={rulesCodeBlock.code_block || ''}
              onChange={handleRulesCodeChange}
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="assign-ruleset-cd">Ruleset Code</Label>
            <Input
              id="assign-ruleset-cd"
              value={assignment.ruleset_cd || ''}
              onChange={(e) => updateAssignmentField('ruleset_cd', e.target.value || null)}
              placeholder="External ruleset identifier"
            />
          </FormGroup>
        </>
      )}

      {assignment.algorithm === 'ai_smart' && (
        <FormGroup>
          <Label htmlFor="assign-ai-policy-cd">AI Policy Code</Label>
          <Input
            id="assign-ai-policy-cd"
            value={assignment.ai_policy_cd || ''}
            onChange={(e) => updateAssignmentField('ai_policy_cd', e.target.value || null)}
            placeholder="AI/ML assignment policy identifier"
          />
        </FormGroup>
      )}

      {assignment.algorithm === 'dynamic' && (
        <FormGroup>
          <Label>Dynamic Code (Python, for dynamic)</Label>
          <PythonCodeEditor
            value={dynamicCodeBlock.code_block || ''}
            onChange={handleDynamicCodeChange}
          />
        </FormGroup>
      )}
    </>
  );
};

const PlannerNodeConfig = ({ selectedNode, handleInputChange }) => {
  const [plannerCd, setPlannerCd] = useState(selectedNode?.data?.data?.planner_cd || '');
  const [planners, setPlanners] = useState([]);
  const [isLoadingPlanners, setIsLoadingPlanners] = useState(false);

  useEffect(() => {
    const fetchPlanners = async () => {
      try {
        setIsLoadingPlanners(true);
        const filter = {};
        const sort = {};
        const query = { skip: 0, limit: 200 };
        const response = await getPlanners(filter, sort, query);
        setPlanners(response || []);
      } catch (error) {
        console.error('Error fetching planners for planner node:', error);
      } finally {
        setIsLoadingPlanners(false);
      }
    };

    fetchPlanners();
  }, []);

  const handlePlannerChange = (value) => {
    setPlannerCd(value);
    handleInputChange('data.planner_cd', value);
  };

  const currentQueryBlock = selectedNode?.data?.data?.query_code_block || { lang: 'python', code_block: '' };
  const currentOutputSchema = selectedNode?.data?.data?.output_schema || { source: 'example', sample_example: '' };

  const handleQueryCodeChange = (val) => {
    const updated = {
      lang: currentQueryBlock.lang || 'python',
      code_block: val || '',
    };
    handleInputChange('data.query_code_block', updated);
  };

  const handleOutputSourceChange = (value) => {
    const updated = {
      ...currentOutputSchema,
      source: value || 'example',
    };
    handleInputChange('data.output_schema', updated);
  };

  const handleSampleExampleChange = (value) => {
    const updated = {
      ...currentOutputSchema,
      source: currentOutputSchema.source || 'example',
      sample_example: value,
    };
    handleInputChange('data.output_schema', updated);
  };

  return (
    <>
      <FormGroup>
        <Label htmlFor="planner-cd">Planner</Label>
        <Select
          id="planner-cd"
          value={plannerCd}
          onChange={(e) => handlePlannerChange(e.target.value)}
          disabled={isLoadingPlanners}
        >
          <option value="">{isLoadingPlanners ? 'Loading planners...' : 'Select planner'}</option>
          {planners?.map((planner) => (
            <option key={planner.id || planner.code} value={planner.code}>
              {planner.name} ({planner.code})
            </option>
          ))}
        </Select>
      </FormGroup>

      <FormGroup>
        <Label>Query Code (Python)</Label>
        <PythonCodeEditor
          value={currentQueryBlock.code_block || ''}
          onChange={handleQueryCodeChange}
        />
      </FormGroup>

      <FormGroup>
        <Label htmlFor="planner-output-source">Output Schema Source</Label>
        <Select
          id="planner-output-source"
          value={currentOutputSchema.source || 'example'}
          onChange={(e) => handleOutputSourceChange(e.target.value)}
        >
          <option value="example">Example</option>
          <option value="code">Code</option>
        </Select>
      </FormGroup>

      <FormGroup>
        <Label htmlFor="planner-output-example">Sample Example</Label>
        <Textarea
          id="planner-output-example"
          value={currentOutputSchema.sample_example || ''}
          onChange={(e) => handleSampleExampleChange(e.target.value)}
          placeholder="Enter a sample JSON/output example"
        />
      </FormGroup>
    </>
  );
};

const EntityOperationNodeConfig = ({ selectedNode, handleInputChange }) => {
  const [operation, setOperation] = useState(selectedNode?.data?.data?.entity_operation || 'save');
  const [entityConfigs, setEntityConfigs] = useState([]);
  const [isLoadingEntities, setIsLoadingEntities] = useState(false);

  useEffect(() => {
    const fetchEntities = async () => {
      try {
        setIsLoadingEntities(true);
        const filters = { type: 'entity' };
        const sort = {};
        const query = 'skip=0&limit=200';
        const response = await getAllEntitiesByFilter(filters, sort, query);
        // Expecting response as array of entity configs
        setEntityConfigs(response || []);
      } catch (error) {
        console.error('Error fetching entity configs for entity_operation node:', error);
      } finally {
        setIsLoadingEntities(false);
      }
    };

    fetchEntities();
  }, []);

  useEffect(() => {
    const nodeData = selectedNode?.data?.data || {};

    if (!nodeData.entity_data_code_block) {
      handleInputChange('data.entity_data_code_block', {
        lang: 'python',
        code_block: "entity = request.get('content')\nentity['id']=0",
      });
    }

    if (!nodeData.filter_query_code_block) {
      handleInputChange('data.filter_query_code_block', {
        lang: 'python',
        code_block: '',
      });
    }

    if (!nodeData.entity_output_code_block) {
      handleInputChange('data.entity_output_code_block', {
        lang: 'python',
        code_block: "response = entity_output\nworkflow_vars['policy_rules_and_insight_agent_response'] = entity_output",
      });
    }
  }, [selectedNode?.id, handleInputChange]);

  const handleOperationChange = (value) => {
    setOperation(value);
    handleInputChange('data.entity_cd', '');
    handleInputChange('data.entity_operation', value);
    // Clear entity_cd when operation changes
  };

  const handleEntityChange = (value) => {
    handleInputChange('data.entity_cd', value);
  };

  const currentEntityCd = selectedNode?.data?.data?.entity_cd || '';

  const entityDataCodeBlock = selectedNode?.data?.data?.entity_data_code_block || {
    lang: 'python',
    code_block: "entity = request.get('content')\nentity['id']=0",
  };

  const filterQueryCodeBlock = selectedNode?.data?.data?.filter_query_code_block || {
    lang: 'python',
    code_block: '',
  };

  const entityOutputCodeBlock = selectedNode?.data?.data?.entity_output_code_block || {
    lang: 'python',
    code_block: "response = entity_output\nworkflow_vars['policy_rules_and_insight_agent_response'] = entity_output",
  };

  const handleEntityDataCodeChange = (val) => {
    handleInputChange('data.entity_data_code_block', {
      lang: entityDataCodeBlock.lang || 'python',
      code_block: val || '',
    });
  };

  const handleFilterQueryCodeChange = (val) => {
    handleInputChange('data.filter_query_code_block', {
      lang: filterQueryCodeBlock.lang || 'python',
      code_block: val || '',
    });
  };

  const handleEntityOutputCodeChange = (val) => {
    handleInputChange('data.entity_output_code_block', {
      lang: entityOutputCodeBlock.lang || 'python',
      code_block: val || '',
    });
  };

  return (
    <>
      <FormGroup>
        <Label htmlFor="entity-operation">Operation</Label>
        <Select
          id="entity-operation"
          value={operation}
          onChange={(e) => handleOperationChange(e.target.value)}
        >
          <option value="save">Save</option>
          <option value="delete">Delete</option>
          <option value="fetch">Fetch</option>
          <option value="fetch_one">Fetch One</option>
        </Select>
      </FormGroup>

      <FormGroup>
        <Label htmlFor="entity-config">Entity Config</Label>
        <Select
          id="entity-config"
          value={currentEntityCd}
          onChange={(e) => handleEntityChange(e.target.value)}
          disabled={isLoadingEntities}
        >
          <option value="">{isLoadingEntities ? 'Loading entities...' : 'Select entity'}</option>
          {entityConfigs?.map((ent) => (
            <option key={ent.id} value={ent.code}>
              {ent.name} ({ent.code})
            </option>
          ))}
        </Select>
      </FormGroup>

      {operation === 'save' && (
        <FormGroup>
          <Label>Entity Data Code (Python)</Label>
          <PythonCodeEditor
            value={entityDataCodeBlock.code_block || ''}
            onChange={handleEntityDataCodeChange}
          />
        </FormGroup>
      )}

      {(operation === 'fetch' || operation === 'fetch_one') && (
        <FormGroup>
          <Label>Filter Query Code (Python)</Label>
          <PythonCodeEditor
            value={filterQueryCodeBlock.code_block || ''}
            onChange={handleFilterQueryCodeChange}
          />
        </FormGroup>
      )}

      <FormGroup>
        <Label>Entity Output Code (Python)</Label>
        <PythonCodeEditor
          value={entityOutputCodeBlock.code_block || ''}
          onChange={handleEntityOutputCodeChange}
        />
      </FormGroup>
    </>
  );
};

const TaskNode = ({ selectedNode, handleInputChange, selectedPipeline = {} }) => {
  const [entityData, setEntityData] = useState([]);
  const [entityDocumentData, setEntityDocumentData] = useState([]);
  const [entityCount, setEntityCount] = useState(0);
  const [entityDocumentCount, setEntityDocumentCount] = useState(0);
  const [userList, setUserList] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const [fieldNodeConfig, setFieldNodeConfig] = useState([]);
  const [formValues, setFormValues] = useState(selectedNode.data.data || {});



  const mandetoryFildsOfTask = mandatoryFields['taskServiceNode'];
  const customFieldValues = {
    entity : entityData,
    associated_entities : entityData,
    docs : entityDocumentData,
    assigned_user: userList,
    assigned_group : userGroups
  }

  useEffect(() => {
    const fetchEntityCount = async () => {
      const resp = await fetchCountByFilter("entity", {type:'entity'});
      if (resp) {
        console.log("entitycount", resp)
        setEntityCount(resp)
      }
    }

    const fetchEntityDocumentCount = async () => {
      const resp = await fetchCountByFilter("entity", {type:'document'});
      if(resp) {
        console.log("doccount", resp)
        setEntityDocumentCount(resp);
      }
    }

    const getUsers = async () => {
      const resp = await fetchUsers();
      if(resp) {
        const updatedUser = resp.map((user) => (
          { id:user.id ,
            name: `${user.first_name} ${user.last_name}`,
            userName: user.username,
            lastLoginUser: user.last_logged_in_company_cd
          }
        ))
        setUserList(updatedUser);
      }
    }

    const getUserGroups = async () => {
      const resp = await fetchUsersGropus();
      if(resp) {
        setUserGroups(resp);
      }
    }

    const fetchMetadata = async () => {
      if(cachedTaskNodeConfig) {
        setFieldNodeConfig(cachedTaskNodeConfig)
      }
      const resp = await getNodeConfig('task_service')
      const attrs = resp['attributes'] || [];
      setFieldNodeConfig(attrs)
      cachedTaskNodeConfig = attrs;

    }

    getUsers();
    getUserGroups();
    fetchEntityCount();
    fetchEntityDocumentCount();
    fetchMetadata();
  }, [])


  useEffect(() => {
    if(selectedNode.type == "taskServiceNode") {
    setDefaultEntitysAndAssosiatedEntities();
    }
  }, [selectedNode.id])


  useEffect(() => {
    const fetchEntites = async () => {
      const query = {skip: 0, limit: entityCount};
      const filter = {type: 'entity'};
      const sort = {};
      const resp = await getEntitiesByPagination(filter, sort, query);
      const filteredDataModelEntities = resp?.map((entity) => {
        return {
          id: entity.id,
          name: entity.name,
          description: entity.description || entity.desc
        }
      })
      setEntityData(filteredDataModelEntities)
    }
    if (entityCount !== 0) fetchEntites()

  }, [entityCount])

   useEffect(() => {
    const fetchDocEntites = async () => {
      const query = {skip: 0, limit: entityDocumentCount};
      const filter = {type:'document'};
      const sort = {};
      const resp = await getEntitiesByPagination(filter, sort, query);
      setEntityDocumentData(resp)
      console.log("doc resp", resp)
    }
    if (entityDocumentCount !== 0) fetchDocEntites()

  }, [entityDocumentCount])

  const handleMultiselectDropdownChange = (path, data) => {
    handleInputChange(path, data);
  }

  const isMandetoryField = (name) => {
    if(mandetoryFildsOfTask.includes(name)) {
       return <i class="fa-solid fa-asterisk" style={{fontSize:'8px', marginLeft:'4px', color:'#d10000'}}></i>
    }
  }

  const setDefaultEntitysAndAssosiatedEntities = () => {
    const rootEntity = selectedPipeline?.entity_name || "";
    const defaultEntity = [{ id: Date.now(), name: rootEntity, description: "" }]
    !formValues['entity'] && rootEntity && handleMultiselectDropdownChange('data.entity', defaultEntity);

    const rooAssociatedEntites = selectedPipeline?.associated_entities?.map((ele) => {
      return {
        id: new Date(),
        name: ele.entity_name,
        description: ""
      }
    });

    !formValues['associated_entities'] && rooAssociatedEntites && handleMultiselectDropdownChange('data.associated_entities', rooAssociatedEntites)
  }

  
  const handleChange = (name, value) => {
    setFormValues((prev) => {
      const updated = { ...prev, [name]: value }
      handleInputChange(`data.${name}`, value);
      return updated
    })
  }
  return (
    <>
      {fieldNodeConfig?.map((field) => (
        <DynamicField
          key={field.name}
          field={field}
          value={formValues[field.name]}
          onChange={handleChange}
          customFieldValues={customFieldValues}
        />
      ))}
    </>
  )
}

const EmailNode = ({selectedNode, handleInputChange, selectedPipeline = {} }) => {
  const [templateCodes, setTemplateCodes] = useState([]);

  useEffect(() => {
    const fetchTemplteCodes = async () => {
      try {
        const resp = await getTemplateCodes();
        const bodyTemplates = resp?.filter((item) => !item.type || item.type === 'body') || [];
        const templtes = bodyTemplates.map((item) => ({id:item.id, label: item.name, value:item.code}));
        setTemplateCodes(templtes);
      } catch (error) {
        console.error('Error fetching template codes for EmailNode:', error);
      }
    }

    fetchTemplteCodes();
  },[]);

  console.log("selectd node",selectedNode)
  console.log("selectd node",selectedNode)

   return (
      <>
        <FormGroup>
          <Label htmlFor="tool-from">From</Label>
          <Input
            id="tool-from"
            value={selectedNode.data.data.frm || ''}
            onChange={(e) => handleInputChange('data.frm', e.target.value)}
            placeholder="e.g. meta-agent@metamorphtech.com"
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="tool-to">To</Label>
          <Input
            id="tool-to"
            value={selectedNode.data.data.to || ''}
            onChange={(e) => handleInputChange('data.to', e.target.value)}
            placeholder="e.g. recipient@example.com"
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="tool-cc">CC</Label>
          <Input
            id="tool-cc"
            value={selectedNode.data.data.cc || ''}
            onChange={(e) => handleInputChange('data.cc', e.target.value)}
            placeholder="e.g. cc@example.com"
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="tool-subject">Subject</Label>
          <Input
            id="tool-subject"
            value={selectedNode.data.data.subject || ''}
            onChange={(e) => handleInputChange('data.subject', e.target.value)}
            placeholder=""
          />
        </FormGroup>

                 <FormGroup >
                    <Label htmlFor="template_cd">Template Code 
                                                  </Label>
                    <Select id="template_cd" 
                                 value={selectedNode.data.data.template_cd || ''}
                                 onChange={(e) => handleInputChange('data.template_cd', e.target.value)}
                    >
                      <option value="">Select template</option>
                      {templateCodes?.map((opt, index) => (
                        <option key={opt.id || index} value={opt.value}>{opt.label}</option>
                      ))}
                    </Select>   
                  </FormGroup>




      </>
    );
}

const DocumentNodeConfig = ({ selectedNode, handleInputChange }) => {
  const [templateCodes, setTemplateCodes] = useState([]);

  useEffect(() => {
    const fetchTemplateCodes = async () => {
      try {
        const resp = await getTemplateCodes();
        const attachmentTemplates = resp?.filter((item) => item.type === 'attachment') || [];
        const templates = attachmentTemplates.map((item) => ({ id: item.id, label: item.name, value: item.code })) || [];
        setTemplateCodes(templates);
      } catch (error) {
        console.error('Error fetching template codes:', error);
      }
    };
    fetchTemplateCodes();
  }, []);

  useEffect(() => {
    const nodeData = selectedNode?.data?.data || {};
    if (!nodeData.documents || nodeData.documents.length === 0) {
      const initialDocs = [{
        template_cd: nodeData.template_cd || '',
        output_filename: nodeData.output_filename || 'document.pdf',
        from_type: 'html',
        to_type: 'pdf',
        document_input_code_block: {
          lang: 'python',
          code_block: `# Ensure request is a dictionary (handles cases where it's None or empty)\nrequest_dict = request if isinstance(request, dict) else {}\n\n# Add the values that you want to use in the document.\n# All fields in \`input_to_document\` will be available as variables in the template\n# and their values will be replaced during document generation.\n# Example: The key below will override the value of the \`instructions\` variable in the template.\ninput_to_document = {\n    **request_dict,\n    # "instructions": "this is for test",\n}`
        }
      }];
      handleInputChange('data.documents', initialDocs);
    }
  }, [selectedNode?.id]);

  useEffect(() => {
    const nodeData = selectedNode?.data?.data || {};
    if (!nodeData.document_response_code_block || !nodeData.document_response_code_block.code_block) {
      handleInputChange('data.document_response_code_block', {
        lang: 'python',
        code_block: `# response: represents the final payload returned by this node.\n# document_output: a list of dictionaries containing metadata of the generated documents.\n# Example format of document_output:\n# [\n#     {\n#         "file_url": "/files/a8b2984a-3fb9-4c8d-8e42-1e9bf8c8e1f5.pdf",\n#         "file_name": "document.pdf",\n#         "success": True\n#     }\n# ]\n\nresponse = document_output\nworkflow_vars['document_response'] = document_output`,
      });
    }
  }, [selectedNode?.id, handleInputChange]);

  const data = selectedNode?.data?.data || {};
  const documents = data.documents || [{ 
    template_cd: data.template_cd || '', 
    output_filename: data.output_filename || 'document.pdf', 
    from_type: 'html', 
    to_type: 'pdf', 
    document_input_code_block: {
      lang: 'python',
      code_block: `# Ensure request is a dictionary (handles cases where it's None or empty)\nrequest_dict = request if isinstance(request, dict) else {}\n\n# Add the values that you want to use in the document.\n# All fields in \`input_to_document\` will be available as variables in the template\n# and their values will be replaced during document generation.\n# Example: The key below will override the value of the \`instructions\` variable in the template.\ninput_to_document = {\n    **request_dict,\n    # "instructions": "this is for test",\n}`
    } 
  }];
  const currentResponseBlock = data.document_response_code_block || { lang: 'python', code_block: '' };

  const handleDocumentChange = (index, field, value) => {
    const updatedDocs = [...documents];
    updatedDocs[index] = {
      ...updatedDocs[index],
      [field]: value
    };
    handleInputChange('data.documents', updatedDocs);

    // Sync first document back to top-level fields for legacy compatibility
    if (index === 0) {
      if (field === 'template_cd') {
        handleInputChange('data.template_cd', value);
      } else if (field === 'output_filename') {
        handleInputChange('data.output_filename', value);
      }
    }
  };

  const handleAddDocument = () => {
    const updatedDocs = [
      ...documents,
      { 
        template_cd: '', 
        output_filename: `document_${documents.length + 1}.pdf`, 
        from_type: 'html', 
        to_type: 'pdf', 
        document_input_code_block: {
          lang: 'python',
          code_block: `# Ensure request is a dictionary (handles cases where it's None or empty)\nrequest_dict = request if isinstance(request, dict) else {}\n\n# Add the values that you want to use in the document.\n# All fields in \`input_to_document\` will be available as variables in the template\n# and their values will be replaced during document generation.\n# Example: The key below will override the value of the \`instructions\` variable in the template.\ninput_to_document = {\n    **request_dict,\n    # "instructions": "this is for test",\n}`
        }
      }
    ];
    handleInputChange('data.documents', updatedDocs);
  };

  const handleRemoveDocument = (index) => {
    const updatedDocs = documents.filter((_, i) => i !== index);
    handleInputChange('data.documents', updatedDocs);
    if (index === 0 && updatedDocs.length > 0) {
      handleInputChange('data.template_cd', updatedDocs[0].template_cd);
      handleInputChange('data.output_filename', updatedDocs[0].output_filename);
    }
  };

  const handleResponseBlockChange = (val) => {
    const updated = {
      lang: 'python',
      code_block: val || '',
    };
    handleInputChange('data.document_response_code_block', updated);
  };

  return (
    <>
      <div style={{ marginBottom: '1.5rem', borderBottom: '1px solid #eee', paddingBottom: '1rem' }}>
        <Label style={{ fontWeight: '600', fontSize: '1rem', display: 'block', marginBottom: '1rem' }}>Documents List</Label>
        
        {documents.map((doc, idx) => (
          <div key={idx} style={{ 
            background: '#f8fafc', 
            padding: '12px', 
            borderRadius: '8px', 
            marginBottom: '1rem', 
            border: '1px solid #e2e8f0',
            position: 'relative'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
              <span style={{ fontWeight: '500', fontSize: '0.9rem', color: '#475569' }}>Document #{idx + 1}</span>
              {documents.length > 1 && (
                <button 
                  type="button"
                  onClick={() => handleRemoveDocument(idx)}
                  style={{ 
                    padding: '2px 8px', 
                    fontSize: '0.75rem', 
                    color: '#ef4444', 
                    background: '#fef2f2',
                    border: '1px solid #fee2e2',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Remove
                </button>
              )}
            </div>

            <FormGroup style={{ marginBottom: '8px' }}>
              <Label htmlFor={`from_type_${idx}`}>Convert From</Label>
              <Select
                id={`from_type_${idx}`}
                value={doc.from_type || 'html'}
                onChange={(e) => handleDocumentChange(idx, 'from_type', e.target.value)}
              >
                <option value="html">HTML</option>
              </Select>
            </FormGroup>

            <FormGroup style={{ marginBottom: '8px' }}>
              <Label htmlFor={`to_type_${idx}`}>Convert To</Label>
              <Select
                id={`to_type_${idx}`}
                value={doc.to_type || 'pdf'}
                onChange={(e) => handleDocumentChange(idx, 'to_type', e.target.value)}
              >
                <option value="pdf">PDF</option>
              </Select>
            </FormGroup>

            <FormGroup style={{ marginBottom: '8px' }}>
              <Label htmlFor={`template_cd_${idx}`}>HTML Template</Label>
              <Select
                id={`template_cd_${idx}`}
                value={doc.template_cd || ''}
                onChange={(e) => handleDocumentChange(idx, 'template_cd', e.target.value)}
              >
                <option value="">Select template</option>
                {templateCodes?.map((opt, index) => (
                  <option key={opt.id || index} value={opt.value}>
                    {opt.label} ({opt.value})
                  </option>
                ))}
              </Select>
            </FormGroup>

            <FormGroup style={{ marginBottom: '8px' }}>
              <Label htmlFor={`output_filename_${idx}`}>Output Filename</Label>
              <Input
                id={`output_filename_${idx}`}
                value={doc.output_filename || ''}
                onChange={(e) => handleDocumentChange(idx, 'output_filename', e.target.value)}
                placeholder="e.g. invoice.pdf"
              />
            </FormGroup>

            <FormGroup style={{ marginBottom: '0' }}>
              <Label>Input Param to Document (Python)</Label>
              <PythonCodeEditor
                value={doc.document_input_code_block?.code_block || ''}
                onChange={(val) => {
                  const updatedCodeBlock = {
                    lang: 'python',
                    code_block: val || ''
                  };
                  handleDocumentChange(idx, 'document_input_code_block', updatedCodeBlock);
                }}
              />
            </FormGroup>
          </div>
        ))}

        <button 
          type="button"
          onClick={handleAddDocument}
          style={{ 
            width: '100%', 
            padding: '8px', 
            fontSize: '0.85rem', 
            background: 'var(--primary-600, #0066FF)', 
            color: '#fff', 
            border: 'none', 
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: '500'
          }}
        >
          + Add Document
        </button>
      </div>

      <FormGroup>
        <Label>Document Response Code (Python)</Label>
        <PythonCodeEditor
          value={currentResponseBlock.code_block || ''}
          onChange={handleResponseBlockChange}
        />
      </FormGroup>
    </>
  );
};

const TimerNode = ({ selectedNode, handleInputChange }) => {
  const { data } = selectedNode.data;
  const [formValues, setFormValues] = useState(selectedNode.data.data || {});
  const [fieldConfig, setFieldConfig] = useState([]);

  useEffect(() => {
    const getMetadata = async () => {
      if (cachedTimerNodeConfig) {
        setFieldConfig(cachedTimerNodeConfig);
        return;
      }

      const resp = await getNodeConfig('timer_node')
      const attrs = resp['attributes'] || [];
      cachedTimerNodeConfig = attrs;
      setFieldConfig(attrs);
    }

    getMetadata();
  }, [])

  const handleChange = (name, value) => {
    setFormValues((prev) => {
      const updated = { ...prev, [name]: value }
      handleInputChange(`data.${name}`, value);
      return updated
    })
  }

  return (
    <>
      {
        fieldConfig?.map((field) => {
          return <DynamicField
            key={field.name}
            field={field}
            value={formValues[field.name]}
            onChange={handleChange}
          />
        })
      }

    </>
  )
}


const PropertiesPanel = ({
  selectedNode,
  updateNodeProperties,
  pipelineDescription,
  setPipelineDescription,
  selectedPipeline,
  setSelectedPipeline,
  selectedEdge,
  updateEdgeProperties,
}) => {

  const [agentList, setAgentList] = useState();
  const [promptList, setPromptList] = useState();
  const [modelList, setModelList] = useState();
  const [personaList, setPersonaList] = useState();
  const [knowledgeBaseList, setKnowledgeBaseList] = useState([]);
  const [entityList, setEntityList] = useState([]);
  const [workStreamList, setWorkStreamList] = useState([]);
  const [showEvalModal, setShowEvalModal] = useState(false);
  const [workflowVarsMode, setWorkflowVarsMode] = useState('manual'); // 'manual' or 'lastRun'
  const [workflowVars, setWorkflowVars] = useState({});
  const [evalResult, setEvalResult] = useState(null);
  const [isEvaluating, setIsEvaluating] = useState(false);
  const [lastRunVars, setLastRunVars] = useState(null);
  const [localCodes, setLocalCodes] = useState([]);
  const [localMCPServerData, setLocalMCPServerData] = useState({});
  const [isVisisbleMCPTools, setIsVisibleMCPTools] = useState(false)
  const [mcpToolsData, setMcpToolsData] = useState(null);
  const [selectedMCPServer, setSelectedMCPServer] = useState(null);
  const [headerDataConfig, setHeaderDataConfig] = useState([{name:"", value:""}])
  const [requestHeadersConfig, setRequestHeadersConfig] = useState([])
  const [payloadData, setPayloadData] = useState(JSON.stringify(selectedNode?.data?.data?.payload, null, 2))
  const [responseHandlersConfig, setResponseHandlersConfig] = useState([])
  const [inputSchemaDictText, setInputSchemaDictText] = useState(
    JSON.stringify(selectedPipeline?.input_schema_config?.value || {}, null, 2)
  );
  const [inputSchemaDictError, setInputSchemaDictError] = useState('');
  useEffect(() => {
    if (selectedEdge) {
      setLocalCodes(selectedEdge.data?.conditions || []);
    }
  }, [selectedEdge]);


  useEffect(() => {
    if (!selectedNode?.id) return;
    if (
      localMCPServerData.mcp_servers &&
      selectedNode.data?.mcp_servers !== localMCPServerData.mcp_servers
    ) {
      updateNodeProperties(selectedNode.id, { mcp_servers: localMCPServerData.mcp_servers });
    }
  }, [localMCPServerData, updateNodeProperties]);

  useEffect(() => {
    if (selectedNode?.id) {
      if (selectedNode.data?.mcp_servers) {
        setLocalMCPServerData(selectedNode.data.mcp_servers);
      } else {
        setLocalMCPServerData({});
      }
      const headers = selectedNode.data?.data?.headers;
      if (headers && Object.keys(headers).length > 0) {
        setHeaderDataConfig(convertHeadersToConfig(selectedNode.data?.data.headers));
      }
      const requestHeaders = selectedNode.data?.data?.request_headers;
      if (Array.isArray(requestHeaders) && requestHeaders.length > 0) {
        const config = requestHeaders.map((h) => ({
          key: h?.key || '',
          lang: h?.value?.lang || 'python',
          code: h?.value?.code_block || '',
        }));
        setRequestHeadersConfig(config);
      } else {
        setRequestHeadersConfig([{ key: '', lang: 'python', code: '' }]);
      }
      const reqPayload = selectedNode.data?.data?.request_payload;
      if (typeof reqPayload === 'string') {
        handleInputChange('data.request_payload', {
          lang: 'python',
          code_block: reqPayload,
        });
      }
      if (selectedNode?.data?.data?.payload) {
        setPayloadData(JSON.stringify(selectedNode.data.data.payload, null, 2));
      }
      const handlers = selectedNode.data?.data?.response_handlers;
      if (Array.isArray(handlers) && handlers.length > 0) {
        const config = handlers.map((h) => ({
          http_status_code: h?.http_status_code ?? 200,
          lang: h?.response_extraction?.lang || 'python',
          code: h?.response_extraction?.code_block || '',
        }));
        setResponseHandlersConfig(config);
      } else {
        setResponseHandlersConfig([
          { http_status_code: 200, lang: 'python', code: 'response = response' },
        ]);
      }
    }
  }, [selectedNode?.id]);

  useEffect(() => {
    try {
      const v = selectedPipeline?.input_schema_config?.value;
      if (v && typeof v === 'object') {
        setInputSchemaDictText(JSON.stringify(v, null, 2));
      } else if (typeof v === 'string') {
        setInputSchemaDictText(v);
      } else {
        setInputSchemaDictText('{}');
      }
    } catch (e) { }
  }, [selectedPipeline?.input_schema_config?.value]);

  useEffect(() => {
    const fetchData = async () => {
      let query = `skip=0&limit=200`;
      try {
        // Call all APIs concurrently
        const [agents, personas, knowledgeBases, prompt, models, workStreams] = await Promise.all([
          getAgents({ status: "ACTIVE" }, {}, {skip: 0, limit: 200}),
          getPersonas(null, null, query),
          getKnowledgeBaseByPagination({}, {}, {skip: 0 , limit: 200}),
          getPrompts({}, {}, {skip: 0 , limit: 200}),
          getModels(null, null, query),
          getWorkStreams(null, null, query)
        ]);

        // Fetch entities separately
        const entitiesResponse = await getEntitiesByPagination({ type: "entity" }, {}, {skip: 0, limit : 200});

        // Update state with the fetched data
        setAgentList(agents || []);
        setPersonaList(personas || []);
        setKnowledgeBaseList(knowledgeBases || []);
        setPromptList(prompt || []);
        setModelList(models || []);
        setEntityList(entitiesResponse || []);
        console.log("Work streams fetched:", workStreams);
        setWorkStreamList(workStreams || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchMCPServers = async () => {
      try {
        const data = await fetchMCPServer();
        setMcpToolsData(data);
        const MCPServerList = data?.server_indexed_mcp_tools && Object.keys(data?.server_indexed_mcp_tools);
        setSelectedMCPServer(MCPServerList[0]);

      } catch (error) {
        console.log("Something went wrong while fetching the mcp tools.")
      }

    }

    fetchData();
    fetchMCPServers();
    if (selectedNode?.data?.agent_code) { setMCPToolsBasisOnAgent(selectedNode?.data?.agent_code) }
  }, []);

  function convertHeadersToConfig(headersObj) {
    if (!headersObj || typeof headersObj !== "object") return [{ name: "", value: "" }];
    const config = Object.entries(headersObj)?.map(([key, value]) => ({
      name: key,
      value: value
    }));
    return config;
  };

  // Pipeline-level data points (root-level data_points on pipeline)
  const dataPoints = selectedPipeline?.data_points || [];

  // NOTE: setSelectedPipeline here is a wrapper function from PipelineDesigner (not a raw React setter),
  // so we must pass a plain payload object instead of a functional updater.
  const updateDataPoints = (updater) => {
    const current = Array.isArray(dataPoints) ? dataPoints : [];
    const next = typeof updater === 'function' ? updater(current) : updater;
    setSelectedPipeline({ data_points: next });
  };

  // Ensure dev_mode is explicitly set for legacy/new pipelines
  useEffect(() => {
    if (selectedPipeline && typeof selectedPipeline.dev_mode === 'undefined') {
      setSelectedPipeline({ dev_mode: true });
    }
  }, [selectedPipeline, setSelectedPipeline]);

  const handleDataPointFieldChange = (index, field, value) => {
    updateDataPoints((current) => {
      const updated = [...current];
      const existing = updated[index] || {};
      updated[index] = {
        ...existing,
        [field]: value,
      };
      return updated;
    });
  };

  const handleDataPointCodeChange = (index, code) => {
    updateDataPoints((current) => {
      const updated = [...current];
      const existing = updated[index] || {};
      const existingBlock = existing.code_block || { lang: 'python', code_block: '' };
      updated[index] = {
        ...existing,
        code_block: {
          ...existingBlock,
          lang: existingBlock.lang || 'python',
          code_block: code || '',
        },
      };
      return updated;
    });
  };

  const handleAddDataPoint = () => {
    updateDataPoints((current) => ([
      ...current,
      {
        key: '',
        label: '',
        data_type: 'STR',
        business_key: false,
        show_in_header: false,
        format: 'text',
        header_order: (current?.length || 0) + 1,
        description: '',
        code_block: { lang: 'python', code_block: '' },
        currency: '',
        component: '',
      },
    ]));
  };

  const handleRemoveDataPoint = (index) => {
    updateDataPoints((current) => current.filter((_, i) => i !== index));
  };


  if (selectedEdge) {

    const conditions = selectedEdge.data?.conditions || [];


    const handleConditionChange = (idx, value) => {
      const newLocalCodes = [...localCodes];
      newLocalCodes[idx].condition = value;
      setLocalCodes(newLocalCodes);
      // Also update the edge properties in parent
      const newConditions = [...localCodes];
      newConditions[idx].condition = value;
      updateEdgeProperties(selectedEdge.id, { conditions: newConditions });
    };

    const handleLanguageChange = (idx, newLang) => {
      setLocalCodes(prev => {
        const updated = [...prev];
        updated[idx] = { ...updated[idx], lang: newLang };
        return updated;
      });
    };

    const handleAddCondition = () => {
      const currentConditions = Array.isArray(conditions) ? conditions : [];
      const newConditions = [...currentConditions, { lang: '', condition: '' }];
      updateEdgeProperties(selectedEdge.id, { conditions: newConditions });
    };

    const handleRemoveCondition = (idx) => {
      const newConditions = conditions.filter((_, i) => i !== idx);
      updateEdgeProperties(selectedEdge.id, { conditions: newConditions });
    };



    return (
      <PanelContainer>
        <PanelTitle>Edge Properties</PanelTitle>
        <SectionTitle>Conditions</SectionTitle>
        {localCodes?.map((localCode, idx) => (
          <FormGroup key={idx}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Label>Condition {idx + 1}</Label>
              <Select value={localCode.lang}
                onChange={(e) => handleLanguageChange(idx, e.target.value)} style={{ margin: '6px 0' }}>
                <option value="">Select language</option>
                <option value="python">Python</option>
                <option value="eng">English</option>

              </Select>
            </div>

            <PythonCodeEditor
              value={localCode.condition}
              lang={localCode.lang}
              onChange={val => handleConditionChange(idx, val)}
              placeholder={
                localCode?.lang == 'eng'
                  ? 'Enter contextual code'
                  : 'Enter condition code'
              }
            />
            <button
              style={{
                marginTop: '0.3rem',
                background: '#ffe0e0',
                color: '#b00020',
                border: 'none',
                borderRadius: '4px',
                padding: '0.2rem 0.7rem',
                cursor: 'pointer'
              }}
              onClick={() => handleRemoveCondition(idx)}
            >
              Remove
            </button>
          </FormGroup>
        ))}
        <button
          style={{
            background: '#e0f7fa',
            color: '#00796b',
            border: 'none',
            borderRadius: '4px',
            padding: '0.4rem 1rem',
            cursor: 'pointer'
          }}
          onClick={handleAddCondition}
          type="button"
        >
          + Add Condition
        </button>
      </PanelContainer>
    );
  }

  if (!selectedNode) {
    return (
      <PanelContainer>
        <PanelTitle>Properties</PanelTitle>

        <PipelineSection>
          <SectionTitle>Pipeline Properties</SectionTitle>

          <FormGroup>
            <Label htmlFor="pipeline-description">Description</Label>
            <Textarea
              id="pipeline-description"
              value={selectedPipeline?.description || ''}
              onChange={(e) => {
                // Ensure we're creating a new object with all existing properties
                const updatedPipeline = {
                  ...selectedPipeline,
                  description: e.target.value,
                  // Ensure other fields exist with default values if they don't already
                  value_stream: selectedPipeline?.value_stream || '',
                  entity_name: selectedPipeline?.entity_name || '',
                  associated_entities: selectedPipeline?.associated_entities || [],
                  knowledgebase: selectedPipeline?.knowledgebase || ''
                };

                // Convert any string entries in associated_entities to objects with entity_name
                if (updatedPipeline.associated_entities.length > 0) {
                  updatedPipeline.associated_entities = updatedPipeline.associated_entities?.map(entity => {
                    if (typeof entity === 'string') {
                      return { entity_name: entity };
                    }
                    // If it has a name property but not entity_name, convert it
                    if (entity.name && !entity.entity_name) {
                      return { entity_name: entity.name };
                    }
                    return entity;
                  });
                }

                setSelectedPipeline(updatedPipeline);
              }}
              placeholder="Describe the purpose of this pipeline"
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="running-version">Running Version</Label>
            <Select
              id="running-version"
              value={selectedPipeline?.running_version || 'v1'}
              onChange={(e) => {
                const updatedPipeline = {
                  ...selectedPipeline,
                  running_version: e.target.value
                };
                setSelectedPipeline(updatedPipeline);
              }}
            >
              <option value="v1">v1</option>
              <option value="v2">v2</option>
            </Select>
          </FormGroup>

          <FormGroup>
            <Label htmlFor="dev-mode">Dev Mode</Label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <input
                id="dev-mode"
                type="checkbox"
                checked={!!selectedPipeline?.dev_mode}
                onChange={(e) => {
                  const updatedPipeline = {
                    ...selectedPipeline,
                    dev_mode: e.target.checked,
                  };
                  setSelectedPipeline(updatedPipeline);
                }}
              />
              <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
                {selectedPipeline?.dev_mode ? 'Enabled' : 'Disabled'}
              </span>
            </div>
          </FormGroup>

          <FormGroup>
            <Label htmlFor="pipeline-type">Type</Label>
            <Select
              id="pipeline-type"
              value={selectedPipeline?.type || 'pipeline'}
              onChange={(e) => {
                const updatedPipeline = {
                  ...selectedPipeline,
                  type: e.target.value,
                };
                setSelectedPipeline(updatedPipeline);
              }}
            >
              <option value="pipeline">Pipeline</option>
              <option value="tool">Tool</option>
            </Select>
          </FormGroup>

          {selectedPipeline?.running_version === 'v2' && ((selectedPipeline?.type || 'pipeline') === 'tool') && (
            <>
              <SectionTitle>Pipeline Input Schema</SectionTitle>
              {(() => {
                const schema = selectedPipeline?.input_schema_config || {};
                const source = schema?.source || 'example';
                const entityError = source === 'entity' && !(schema?.entity_cd && String(schema?.entity_cd).trim());
                return (
                  <>
                    <FormGroup>
                      <Label htmlFor="pipeline-input-source">Source</Label>
                      <Select
                        id="pipeline-input-source"
                        value={source}
                        onChange={(e) => {
                          const next = { ...(schema || {}), source: e.target.value };
                          setSelectedPipeline({ input_schema_config: next });
                        }}
                      >
                        <option value="example">Example</option>
                        <option value="entity">Entity</option>
                        <option value="dict">Dict</option>
                      </Select>
                    </FormGroup>

                    {source === 'entity' && (
                      <FormGroup>
                        <Label htmlFor="pipeline-input-entity">Entity Code</Label>
                        <Select
                          id="pipeline-input-entity"
                          value={schema?.entity_cd || ''}
                          onChange={(e) => {
                            const next = { ...(schema || {}), source: schema?.source || 'entity', entity_cd: e.target.value };
                            setSelectedPipeline({ input_schema_config: next });
                          }}
                        >
                          <option value="">Select Entity</option>
                          {entityList?.map((ent, idx) => (
                            <option key={idx} value={ent.code || ent.name}>
                              {ent.name}{ent.code ? ` (${ent.code})` : ''}
                            </option>
                          ))}
                        </Select>
                        {entityError && (
                          <div style={{ color: '#b00020', fontSize: '0.8rem', marginTop: 4 }}>Entity code is required.</div>
                        )}
                      </FormGroup>
                    )}

                    {source === 'example' && (
                      <FormGroup>
                        <Label htmlFor="pipeline-input-example">Sample Example</Label>
                        <Textarea
                          id="pipeline-input-example"
                          value={schema?.sample_example || ''}
                          onChange={(e) => {
                            const next = { ...(schema || {}), source: schema?.source || 'example', sample_example: e.target.value };
                            setSelectedPipeline({ input_schema_config: next });
                          }}
                          placeholder="Enter a sample JSON/input example"
                        />
                      </FormGroup>
                    )}

                    {source === 'dict' && (
                      <FormGroup>
                        <Label htmlFor="pipeline-input-dict">Explicit Dict Schema (JSON)</Label>
                        <Textarea
                          id="pipeline-input-dict"
                          value={inputSchemaDictText}
                          onChange={(e) => {
                            const txt = e.target.value;
                            setInputSchemaDictText(txt);
                            try {
                              const parsed = JSON.parse(txt || '{}');
                              setInputSchemaDictError('');
                              const next = { ...(schema || {}), source: schema?.source || 'dict', value: parsed };
                              setSelectedPipeline({ input_schema_config: next });
                            } catch (err) {
                              setInputSchemaDictError('Invalid JSON');
                            }
                          }}
                          placeholder="{ }"
                        />
                        {inputSchemaDictError && (
                          <div style={{ color: '#b00020', fontSize: '0.8rem', marginTop: 4 }}>{inputSchemaDictError}</div>
                        )}
                      </FormGroup>
                    )}
                  </>
                );
              })()}
            </>
          )}

          <FormGroup>
            <Label htmlFor="value-stream">Value Stream</Label>
            <Select
              id="value-stream"
              value={selectedPipeline?.value_stream || ''}
              onChange={(e) => {
                const updatedPipeline = {
                  ...selectedPipeline,
                  value_stream: e.target.value,
                  // Ensure other fields exist
                  description: selectedPipeline?.description || '',
                  entity_name: selectedPipeline?.entity_name || '',
                  associated_entities: selectedPipeline?.associated_entities || [],
                  knowledgebase: selectedPipeline?.knowledgebase || ''
                };

                // Convert any string entries in associated_entities to objects with entity_name
                if (updatedPipeline.associated_entities.length > 0) {
                  updatedPipeline.associated_entities = updatedPipeline.associated_entities?.map(entity => {
                    if (typeof entity === 'string') {
                      return { entity_name: entity };
                    }
                    // If it has a name property but not entity_name, convert it
                    if (entity.name && !entity.entity_name) {
                      return { entity_name: entity.name };
                    }
                    return entity;
                  });
                }

                setSelectedPipeline(updatedPipeline);
              }}
            >
              <option value="">Select Work Stream</option>
              {workStreamList && workStreamList.length > 0 ? (
                workStreamList?.map((stream, index) => (
                  <option key={index} value={stream.name}>{stream.name}</option>
                ))
              ) : (
                <>
                  <option value="New Business">New Business</option>
                  <option value="Claims Processing">Claims Processing</option>
                  <option value="Servicing">Servicing</option>
                  <option value="Fraud waste and abuse">Fraud waste and abuse</option>
                </>
              )}
            </Select>
          </FormGroup>

          <FormGroup>
            <Label htmlFor="entity-name">Entity Name</Label>
            <Select
              id="entity-name"
              value={selectedPipeline?.entity_name || ''}
              onChange={(e) => {
                const updatedPipeline = {
                  ...selectedPipeline,
                  entity_name: e.target.value,
                  // Ensure other fields exist
                  description: selectedPipeline?.description || '',
                  value_stream: selectedPipeline?.value_stream || '',
                  associated_entities: selectedPipeline?.associated_entities || [],
                  knowledgebase: selectedPipeline?.knowledgebase || ''
                };

                // Convert any string entries in associated_entities to objects with entity_name
                if (updatedPipeline.associated_entities.length > 0) {
                  updatedPipeline.associated_entities = updatedPipeline.associated_entities?.map(entity => {
                    if (typeof entity === 'string') {
                      return { entity_name: entity };
                    }
                    // If it has a name property but not entity_name, convert it
                    if (entity.name && !entity.entity_name) {
                      return { entity_name: entity.name };
                    }
                    return entity;
                  });
                }

                setSelectedPipeline(updatedPipeline);
              }}
            >
              <option value="">Select Entity</option>
              {entityList?.map((entity, index) => (
                <option key={index} value={entity.name}>{entity.name}</option>
              ))}
            </Select>
          </FormGroup>

          <FormGroup>
            <Label>Associated Entities</Label>
            <div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px' }}>
                <Select
                  id="entity-select"
                  style={{ flex: 1 }}
                >
                  <option value="">Select Entity to Add</option>
                  {entityList.filter(entity => {
                    // Filter out entities that are already in associated_entities
                    const associated = selectedPipeline?.associated_entities || [];
                    return !associated.some(item =>
                      (typeof item === 'object' && item?.entity_name === entity.name)
                    );
                  })?.map((entity, index) => (
                    <option key={index} value={entity.name}>{entity.name}</option>
                  ))}
                </Select>
                <button
                  type="button"
                  style={{
                    background: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    padding: '8px 12px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px'
                  }}
                  onClick={() => {
                    const selectElement = document.getElementById('entity-select');
                    if (!selectElement || !selectElement.value) return;

                    const entityName = selectElement.value;
                    const currentEntities = selectedPipeline?.associated_entities || [];

                    // Create entity object with entity_name property
                    const entityToAdd = { entity_name: entityName };

                    // Prevent duplicate entities by checking entity_name
                    if (currentEntities.some(item =>
                      (typeof item === 'object' && item?.entity_name === entityName)
                    )) return;

                    const updatedPipeline = {
                      ...selectedPipeline,
                      associated_entities: [...currentEntities, entityToAdd],
                      // Ensure other fields exist
                      description: selectedPipeline?.description || '',
                      value_stream: selectedPipeline?.value_stream || '',
                      entity_name: selectedPipeline?.entity_name || '',
                      knowledgebase: selectedPipeline?.knowledgebase || ''
                    };
                    setSelectedPipeline(updatedPipeline);

                    // Reset the select to default option after adding
                    selectElement.value = '';
                  }}
                >
                  + Add Entity
                </button>
              </div>



              <TagsContainer>
                {(selectedPipeline?.associated_entities || [])?.map((entity, index) => {
                  // Get entity name from the entity_name property
                  const entityName = entity.entity_name || 'Unknown Entity';

                  return (
                    <Tag key={index}>
                      {entityName}
                      <RemoveTag onClick={() => {
                        const newEntities = [...(selectedPipeline?.associated_entities || [])];
                        newEntities.splice(index, 1);
                        const updatedPipeline = {
                          ...selectedPipeline,
                          associated_entities: newEntities,
                          // Ensure other fields exist
                          description: selectedPipeline?.description || '',
                          value_stream: selectedPipeline?.value_stream || '',
                          entity_name: selectedPipeline?.entity_name || '',
                          knowledgebase: selectedPipeline?.knowledgebase || ''
                        };
                        setSelectedPipeline(updatedPipeline);
                      }}>✕</RemoveTag>
                    </Tag>
                  );
                })}
                {(selectedPipeline?.associated_entities || []).length === 0 && (
                  <div style={{ color: '#888', fontSize: '0.9rem' }}>No associated entities selected</div>
                )}
              </TagsContainer>
            </div>
          </FormGroup>

          <FormGroup>
            <Label htmlFor="knowledgebase">Knowledge Base</Label>
            <Select
              id="knowledgebase"
              value={selectedPipeline?.knowledgebase || ''}
              onChange={(e) => {
                const updatedPipeline = {
                  ...selectedPipeline,
                  knowledgebase: e.target.value,
                  // Ensure other fields exist
                  description: selectedPipeline?.description || '',
                  value_stream: selectedPipeline?.value_stream || '',
                  entity_name: selectedPipeline?.entity_name || '',
                  associated_entities: selectedPipeline?.associated_entities || []
                };

                // Convert any string entries in associated_entities to objects with entity_name
                if (updatedPipeline.associated_entities.length > 0) {
                  updatedPipeline.associated_entities = updatedPipeline.associated_entities?.map(entity => {
                    if (typeof entity === 'string') {
                      return { entity_name: entity };
                    }
                    // If it has a name property but not entity_name, convert it
                    if (entity.name && !entity.entity_name) {
                      return { entity_name: entity.name };
                    }
                    return entity;
                  });
                }

                setSelectedPipeline(updatedPipeline);
              }}
            >
              <option value="">Select Knowledge Base</option>
              {knowledgeBaseList?.map((kb, index) => (
                <option key={index} value={kb.code}>{kb.name}</option>
              ))}
            </Select>
          </FormGroup>

          <FormGroup>
            <Label htmlFor='prefix'>Prefix</Label>
            <Input placeholder='Enter prefix'
             id="prefix"
             onChange={(e) => {
                const updatedPipeline = {
                  ...selectedPipeline,
                  prefix: e.target.value
                };
                setSelectedPipeline(updatedPipeline)
              
            }} />
          </FormGroup>
          

          

          <SectionTitle>Data Points</SectionTitle>

          {dataPoints?.map((dp, index) => {
            const codeBlock = dp.code_block || { lang: 'python', code_block: '' };
            return (
              <div
                key={index}
                style={{
                  border: '1px solid #e0e0e0',
                  borderRadius: 6,
                  padding: '0.75rem',
                  marginBottom: '0.75rem',
                  background: '#fafafa',
                }}
              >
                <FormGroup>
                  <Label htmlFor={`dp-key-${index}`}>Key</Label>
                  <Input
                    id={`dp-key-${index}`}
                    value={dp.key || ''}
                    onChange={(e) => handleDataPointFieldChange(index, 'key', e.target.value)}
                    placeholder="e.g. caseId"
                  />
                </FormGroup>

                <FormGroup>
                  <Label htmlFor={`dp-label-${index}`}>Label</Label>
                  <Input
                    id={`dp-label-${index}`}
                    value={dp.label || ''}
                    onChange={(e) => handleDataPointFieldChange(index, 'label', e.target.value)}
                    placeholder="e.g. Case Id"
                  />
                </FormGroup>

                <FormGroup>
                  <Label htmlFor={`dp-data-type-${index}`}>Data Type</Label>
                  <Select
                    id={`dp-data-type-${index}`}
                    value={dp.data_type || 'STR'}
                    onChange={(e) => handleDataPointFieldChange(index, 'data_type', e.target.value)}
                  >
                    <option value="STR">String</option>
                    <option value="INT">Integer</option>
                    <option value="FLOAT">Float</option>
                  </Select>
                </FormGroup>

                <FormGroup>
                  <Label>Flags</Label>
                  <div style={{ display: 'flex', gap: '1rem', fontSize: '0.85rem' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <input
                        type="checkbox"
                        checked={dp.business_key || false}
                        onChange={(e) => handleDataPointFieldChange(index, 'business_key', e.target.checked)}
                      />
                      Business Key
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <input
                        type="checkbox"
                        checked={dp.show_in_header || false}
                        onChange={(e) => handleDataPointFieldChange(index, 'show_in_header', e.target.checked)}
                      />
                      Show in Header
                    </label>
                  </div>
                </FormGroup>

                <FormGroup>
                  <Label htmlFor={`dp-format-${index}`}>Format</Label>
                  <Select
                    id={`dp-format-${index}`}
                    value={dp.format || ''}
                    onChange={(e) => handleDataPointFieldChange(index, 'format', e.target.value)}
                  >
                    <option value="">None</option>
                    <option value="text">Text</option>
                    <option value="currency">Currency</option>
                    <option value="percentage">Percentage</option>
                    <option value="username">Username</option>
                  </Select>
                </FormGroup>

                {dp.format === 'currency' && (
                  <FormGroup>
                    <Label htmlFor={`dp-currency-${index}`}>Currency</Label>
                    <Input
                      id={`dp-currency-${index}`}
                      value={dp.currency || ''}
                      onChange={(e) => handleDataPointFieldChange(index, 'currency', e.target.value)}
                      placeholder="e.g. USD, INR"
                    />
                  </FormGroup>
                )}

                <FormGroup>
                  <Label htmlFor={`dp-header-order-${index}`}>Header Order</Label>
                  <Input
                    id={`dp-header-order-${index}`}
                    type="number"
                    value={dp.header_order ?? ''}
                    onChange={(e) =>
                      handleDataPointFieldChange(
                        index,
                        'header_order',
                        e.target.value === '' ? null : Number(e.target.value)
                      )
                    }
                  />
                </FormGroup>

                <FormGroup>
                  <Label htmlFor={`dp-component-${index}`}>Component</Label>
                  <Select
                    id={`dp-component-${index}`}
                    value={dp.component || ''}
                    onChange={(e) => handleDataPointFieldChange(index, 'component', e.target.value)}
                  >
                    <option value="">Default</option>
                    <option value="header">Header</option>
                    <option value="subheader">Subheader</option>
                    <option value="metrics">Metrics</option>
                    <option value="details">Details</option>
                  </Select>
                </FormGroup>

                <FormGroup>
                  <Label htmlFor={`dp-description-${index}`}>Description</Label>
                  <Textarea
                    id={`dp-description-${index}`}
                    value={dp.description || ''}
                    onChange={(e) => handleDataPointFieldChange(index, 'description', e.target.value)}
                    placeholder="Describe what this data point represents"
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Code (Python)</Label>
                  <PythonCodeEditor
                    value={codeBlock.code_block || ''}
                    onChange={(code) => handleDataPointCodeChange(index, code)}
                  />
                </FormGroup>

                <button
                  type="button"
                  style={{
                    marginTop: '0.25rem',
                    background: '#ffe0e0',
                    color: '#b00020',
                    border: 'none',
                    borderRadius: 4,
                    padding: '0.3rem 0.6rem',
                    cursor: 'pointer',
                    fontSize: '0.8rem',
                  }}
                  onClick={() => handleRemoveDataPoint(index)}
                >
                  Remove Data Point
                </button>
              </div>
            );
          })}

          <button
            type="button"
            style={{
              marginTop: '0.5rem',
              background: '#e0f7e9',
              color: '#2E7D32',
              border: 'none',
              borderRadius: 4,
              padding: '0.4rem 0.8rem',
              cursor: 'pointer',
              fontSize: '0.85rem',
            }}
            onClick={handleAddDataPoint}
          >
            + Add Data Point
          </button>

          {/* Add CRON Scheduler fields */}
          <FormGroup>
            <Label htmlFor="schedule-enabled">
              Schedule Run
              <div style={{ 
                display: 'inline-flex', 
                alignItems: 'center', 
                marginLeft: '10px',
                gap: '8px'
              }}>
                <input
                  type="checkbox"
                  id="schedule-enabled"
                  checked={selectedPipeline?.schedule_enabled || false}
                  onChange={(e) => {
                    const updatedPipeline = {
                      ...selectedPipeline,
                      schedule_enabled: e.target.checked,
                      // Reset cron fields when disabled
                      cron_config: e.target.checked ? (selectedPipeline?.cron_config || {
                        cron_minute: '0',
                        cron_hour: '0',
                        cron_day: '*',
                        cron_month: '*',
                        cron_weekday: '0',
                        cron_command: '0 0 * * 0'
                      }) : {
                        cron_minute: '0',
                        cron_hour: '0',
                        cron_day: '*',
                        cron_month: '*',
                        cron_weekday: '0',
                        cron_command: '0 0 * * 0'
                      }
                    };
                    setSelectedPipeline(updatedPipeline);
                  }}
                  style={{
                    width: '20px',
                    height: '20px',
                    cursor: 'pointer'
                  }}
                />
                <span style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
                  {selectedPipeline?.schedule_enabled ? 'Enabled' : 'Disabled'}
                </span>
              </div>
            </Label>
          </FormGroup>

          {selectedPipeline?.schedule_enabled && (
            <>
              <div style={{
                background: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderRadius: '6px',
                padding: '1rem',
                marginTop: '0.5rem'
              }}>
                <div style={{ 
                  fontSize: '0.9rem', 
                  fontWeight: '500', 
                  marginBottom: '1rem',
                  color: 'var(--text-primary)'
                }}>
                  Common Settings
                </div>
                
                <FormGroup>
                  <Label htmlFor="cron-preset">Schedule Preset</Label>
                  <Select
                    id="cron-preset"
                    onChange={(e) => {
                      const presets = {
                        'daily': { minute: '0', hour: '0', day: '*', month: '*', weekday: '*' },
                        'weekly': { minute: '0', hour: '0', day: '*', month: '*', weekday: '0' },
                        'monthly': { minute: '0', hour: '0', day: '1', month: '*', weekday: '*' },
                        'hourly': { minute: '0', hour: '*', day: '*', month: '*', weekday: '*' }
                      };
                      
                      if (e.target.value && presets[e.target.value]) {
                        const preset = presets[e.target.value];
                        const cronCommand = `${preset.minute} ${preset.hour} ${preset.day} ${preset.month} ${preset.weekday}`;
                        const updatedPipeline = {
                          ...selectedPipeline,
                          cron_config: {
                            ...selectedPipeline?.cron_config,
                            cron_minute: preset.minute,
                            cron_hour: preset.hour,
                            cron_day: preset.day,
                            cron_month: preset.month,
                            cron_weekday: preset.weekday,
                            cron_command: cronCommand
                          }
                        };
                        setSelectedPipeline(updatedPipeline);
                      }
                    }}
                  >
                    <option value="">Select Preset</option>
                    <option value="daily">Daily (At midnight)</option>
                    <option value="weekly">Weekly (Sunday at midnight)</option>
                    <option value="monthly">Monthly (1st at midnight)</option>
                    <option value="hourly">Hourly (Every hour)</option>
                  </Select>
                </FormGroup>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                  <FormGroup>
                    <Label htmlFor="cron-minute">Minute</Label>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <Input
                        id="cron-minute"
                        type="text"
                        value={selectedPipeline?.cron_config?.cron_minute || '0'}
                        onChange={(e) => {
                          const cronConfig = selectedPipeline?.cron_config || {};
                          const newCronConfig = {
                            ...cronConfig,
                            cron_minute: e.target.value,
                            cron_command: `${e.target.value} ${cronConfig.cron_hour || '0'} ${cronConfig.cron_day || '*'} ${cronConfig.cron_month || '*'} ${cronConfig.cron_weekday || '0'}`
                          };
                          const updatedPipeline = {
                            ...selectedPipeline,
                            cron_config: newCronConfig
                          };
                          setSelectedPipeline(updatedPipeline);
                        }}
                        style={{ flex: 1 }}
                        placeholder="0-59 or *"
                      />
                      <Select
                        style={{ flex: 1 }}
                        value={selectedPipeline?.cron_config?.cron_minute || '0'}
                        onChange={(e) => {
                          const cronConfig = selectedPipeline?.cron_config || {};
                          const newCronConfig = {
                            ...cronConfig,
                            cron_minute: e.target.value,
                            cron_command: `${e.target.value} ${cronConfig.cron_hour || '0'} ${cronConfig.cron_day || '*'} ${cronConfig.cron_month || '*'} ${cronConfig.cron_weekday || '0'}`
                          };
                          const updatedPipeline = {
                            ...selectedPipeline,
                            cron_config: newCronConfig
                          };
                          setSelectedPipeline(updatedPipeline);
                        }}
                      >
                        <option value="0">:00 (At the beginning of the hour) (0)</option>
                        <option value="15">:15 (Quarter past) (15)</option>
                        <option value="30">:30 (Half past) (30)</option>
                        <option value="45">:45 (Quarter to) (45)</option>
                        <option value="*">Every minute (*)</option>
                      </Select>
                    </div>
                  </FormGroup>

                  <FormGroup>
                    <Label htmlFor="cron-hour">Hour</Label>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <Input
                        id="cron-hour"
                        type="text"
                        value={selectedPipeline?.cron_config?.cron_hour || '0'}
                        onChange={(e) => {
                          const cronConfig = selectedPipeline?.cron_config || {};
                          const newCronConfig = {
                            ...cronConfig,
                            cron_hour: e.target.value,
                            cron_command: `${cronConfig.cron_minute || '0'} ${e.target.value} ${cronConfig.cron_day || '*'} ${cronConfig.cron_month || '*'} ${cronConfig.cron_weekday || '0'}`
                          };
                          const updatedPipeline = {
                            ...selectedPipeline,
                            cron_config: newCronConfig
                          };
                          setSelectedPipeline(updatedPipeline);
                        }}
                        style={{ flex: 1 }}
                        placeholder="0-23 or *"
                      />
                      <Select
                        style={{ flex: 1 }}
                        value={selectedPipeline?.cron_config?.cron_hour || '0'}
                        onChange={(e) => {
                          const cronConfig = selectedPipeline?.cron_config || {};
                          const newCronConfig = {
                            ...cronConfig,
                            cron_hour: e.target.value,
                            cron_command: `${cronConfig.cron_minute || '0'} ${e.target.value} ${cronConfig.cron_day || '*'} ${cronConfig.cron_month || '*'} ${cronConfig.cron_weekday || '0'}`
                          };
                          const updatedPipeline = {
                            ...selectedPipeline,
                            cron_config: newCronConfig
                          };
                          setSelectedPipeline(updatedPipeline);
                        }}
                      >
                        <option value="0">12:00 a.m. Midnight (0)</option>
                        <option value="6">6:00 a.m. (6)</option>
                        <option value="12">12:00 p.m. Noon (12)</option>
                        <option value="18">6:00 p.m. (18)</option>
                        <option value="*">Every hour (*)</option>
                      </Select>
                    </div>
                  </FormGroup>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                  <FormGroup>
                    <Label htmlFor="cron-day">Day</Label>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <Input
                        id="cron-day"
                        type="text"
                        value={selectedPipeline?.cron_config?.cron_day || '*'}
                        onChange={(e) => {
                          const cronConfig = selectedPipeline?.cron_config || {};
                          const newCronConfig = {
                            ...cronConfig,
                            cron_day: e.target.value,
                            cron_command: `${cronConfig.cron_minute || '0'} ${cronConfig.cron_hour || '0'} ${e.target.value} ${cronConfig.cron_month || '*'} ${cronConfig.cron_weekday || '0'}`
                          };
                          const updatedPipeline = {
                            ...selectedPipeline,
                            cron_config: newCronConfig
                          };
                          setSelectedPipeline(updatedPipeline);
                        }}
                        style={{ flex: 1 }}
                        placeholder="1-31 or *"
                      />
                      <Select
                        style={{ flex: 1 }}
                        value={selectedPipeline?.cron_config?.cron_day || '*'}
                        onChange={(e) => {
                          const cronConfig = selectedPipeline?.cron_config || {};
                          const newCronConfig = {
                            ...cronConfig,
                            cron_day: e.target.value,
                            cron_command: `${cronConfig.cron_minute || '0'} ${cronConfig.cron_hour || '0'} ${e.target.value} ${cronConfig.cron_month || '*'} ${cronConfig.cron_weekday || '0'}`
                          };
                          const updatedPipeline = {
                            ...selectedPipeline,
                            cron_config: newCronConfig
                          };
                          setSelectedPipeline(updatedPipeline);
                        }}
                      >
                        <option value="*">Every Day (*)</option>
                        <option value="1">1st of month</option>
                        <option value="15">15th of month</option>
                        <option value="L">Last day of month</option>
                      </Select>
                    </div>
                  </FormGroup>

                  <FormGroup>
                    <Label htmlFor="cron-month">Month</Label>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <Input
                        id="cron-month"
                        type="text"
                        value={selectedPipeline?.cron_config?.cron_month || '*'}
                        onChange={(e) => {
                          const cronConfig = selectedPipeline?.cron_config || {};
                          const newCronConfig = {
                            ...cronConfig,
                            cron_month: e.target.value,
                            cron_command: `${cronConfig.cron_minute || '0'} ${cronConfig.cron_hour || '0'} ${cronConfig.cron_day || '*'} ${e.target.value} ${cronConfig.cron_weekday || '0'}`
                          };
                          const updatedPipeline = {
                            ...selectedPipeline,
                            cron_config: newCronConfig
                          };
                          setSelectedPipeline(updatedPipeline);
                        }}
                        style={{ flex: 1 }}
                        placeholder="1-12 or *"
                      />
                      <Select
                        style={{ flex: 1 }}
                        value={selectedPipeline?.cron_config?.cron_month || '*'}
                        onChange={(e) => {
                          const cronConfig = selectedPipeline?.cron_config || {};
                          const newCronConfig = {
                            ...cronConfig,
                            cron_month: e.target.value,
                            cron_command: `${cronConfig.cron_minute || '0'} ${cronConfig.cron_hour || '0'} ${cronConfig.cron_day || '*'} ${e.target.value} ${cronConfig.cron_weekday || '0'}`
                          };
                          const updatedPipeline = {
                            ...selectedPipeline,
                            cron_config: newCronConfig
                          };
                          setSelectedPipeline(updatedPipeline);
                        }}
                      >
                        <option value="*">Every Month (*)</option>
                        <option value="1">January</option>
                        <option value="2">February</option>
                        <option value="3">March</option>
                        <option value="4">April</option>
                        <option value="5">May</option>
                        <option value="6">June</option>
                        <option value="7">July</option>
                        <option value="8">August</option>
                        <option value="9">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </Select>
                    </div>
                  </FormGroup>
                </div>

                <FormGroup>
                  <Label htmlFor="cron-weekday">Weekday</Label>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <Input
                      id="cron-weekday"
                      type="text"
                      value={selectedPipeline?.cron_config?.cron_weekday || '0'}
                      onChange={(e) => {
                        const cronConfig = selectedPipeline?.cron_config || {};
                        const newCronConfig = {
                          ...cronConfig,
                          cron_weekday: e.target.value,
                          cron_command: `${cronConfig.cron_minute || '0'} ${cronConfig.cron_hour || '0'} ${cronConfig.cron_day || '*'} ${cronConfig.cron_month || '*'} ${e.target.value}`
                        };
                        const updatedPipeline = {
                          ...selectedPipeline,
                          cron_config: newCronConfig
                        };
                        setSelectedPipeline(updatedPipeline);
                      }}
                      style={{ flex: 1 }}
                      placeholder="0-7 or *"
                    />
                    <Select
                      style={{ flex: 1 }}
                      value={selectedPipeline?.cron_config?.cron_weekday || '0'}
                      onChange={(e) => {
                        const cronConfig = selectedPipeline?.cron_config || {};
                        const newCronConfig = {
                          ...cronConfig,
                          cron_weekday: e.target.value,
                          cron_command: `${cronConfig.cron_minute || '0'} ${cronConfig.cron_hour || '0'} ${cronConfig.cron_day || '*'} ${cronConfig.cron_month || '*'} ${e.target.value}`
                        };
                        const updatedPipeline = {
                          ...selectedPipeline,
                          cron_config: newCronConfig
                        };
                        setSelectedPipeline(updatedPipeline);
                      }}
                    >
                      <option value="0">Sunday (0)</option>
                      <option value="1">Monday (1)</option>
                      <option value="2">Tuesday (2)</option>
                      <option value="3">Wednesday (3)</option>
                      <option value="4">Thursday (4)</option>
                      <option value="5">Friday (5)</option>
                      <option value="6">Saturday (6)</option>
                      <option value="*">Every Day (*)</option>
                    </Select>
                  </div>
                </FormGroup>

                <FormGroup>
                  <Label htmlFor="cron-command">Command (Generated CRON Pattern)</Label>
                  <Input
                    id="cron-command"
                    type="text"
                    value={selectedPipeline?.cron_config?.cron_command || `${selectedPipeline?.cron_config?.cron_minute || '0'} ${selectedPipeline?.cron_config?.cron_hour || '0'} ${selectedPipeline?.cron_config?.cron_day || '*'} ${selectedPipeline?.cron_config?.cron_month || '*'} ${selectedPipeline?.cron_config?.cron_weekday || '0'}`}
                    readOnly
                    style={{
                      background: '#f8f9fa',
                      fontFamily: 'monospace',
                      color: '#495057'
                    }}
                    title="This is the generated CRON expression based on your selections above"
                  />
                  <div style={{
                    fontSize: '0.75rem',
                    color: 'var(--text-secondary)',
                    marginTop: '0.25rem'
                  }}>
                    Format: minute hour day month weekday
                  </div>
                </FormGroup>
              </div>
            </>
          )}

        </PipelineSection>

        {/* <NoSelection>
          Select a node to edit its properties
        </NoSelection> */}
      </PanelContainer>
    );
  }

  const getNodeTypeInfo = (type) => {
    switch (type) {
      case 'triggerNode':
        return {
          label: 'Trigger',
          icon: faPlayCircle,
          background: '#FFF4CC',
          color: '#E6C200'
        };
      case 'outputNode':
        return {
          label: 'Output',
          icon: faCircleStop,
          background: '#FFE5CC',
          color: '#FF9900'
        };
      case 'agentNode':
        return {
          label: 'Agent',
          icon: faUser,
          background: '#CCF2FF',
          color: '#0099CC'
        };
      case 'dataSourceNode':
        return {
          label: 'Data Source',
          icon: faDiagramPredecessor,
          background: '#D9F9F2',
          color: '#26A69A'
        };
      case 'modelNode':
        return {
          label: 'Model',
          icon: faProjectDiagram,
          background: '#CCE5FF',
          color: '#337AB7'
        };
      case 'knowledgeNode':
        return {
          label: 'Knowledgebase',
          icon: faLandmark,
          background: '#E0F7FA',
          color: '#00ACC1'
        };
      case 'toolNode':
        return {
          label: 'Tool',
          icon: '⚒',
          background: '#fff5e6',
          color: '#ff9500'
        };

      case 'apiNode':
        return {
          label: 'API',
          icon: faPlug,
          background: '#E0F7E9',
          color: '#2E7D32'
        };
      case 'taskServiceNode' :
        return {
          label: 'Task',
          icon: faHourglass,
          background:'#EFE9E3',
          color:'#829591'
        }
      case 'emailOutNode':
        return {
          label: 'Email Out',
          icon: faEnvelope,
          background: '#E0F7E9',
          color: '#2E7D32'
        };
      case 'documentNode':
        return {
          label: 'Document conversion',
          icon: faChartDiagram,
          background: '#E0F7FA',
          color: '#00ACC1'
        };

      case 'fileNode':
        return {
          label: 'File Operations',
          icon: faChartDiagram,
          background: '#F0F8FF',
          color: '#4169E1'
        };
      case 'timerNode':
        return {
          label: 'Timer',
          icon: faCalendarTimes,
          background: '#ECF4E8',
          color: '#63A361'
        };
      case 'classifierNode':
        return {
          label: 'Classifier',
          icon: faObjectUngroup,
          background: '#D6F5E3',
          color: '#388E3C'
        };

      case 'codeNode':
        return {
          label: 'Code Block',
          icon: faCode,
          background: '#E4FBE9',
          color: '#43A047'
        };

      case 'webHookNode':
        return {
          label: 'Tool',
          icon: faPaperPlane,
          background: '#D2F8D2',
          color: '#4CAF50'
        };
      case 'plannerNode':
        return {
          label: 'Planner',
          icon: faProjectDiagram,
          background: '#E6F1FF',
          color: '#2F80ED'
        };
      case 'entityOperationNode':
        return {
          label: 'Entity Operation',
          icon: faProjectDiagram,
          background: '#FFF4E6',
          color: '#F2994A'
        };
      default:
        return {
          label: 'Node',
          icon: faDiamond,
          background: '#f0f0f0',
          color: 'var(--text-primary)'
        };
    }
  };



  const nodeTypeInfo = getNodeTypeInfo(selectedNode.type);

  // const handleInputChange = (field, value) => {
  //   updateNodeProperties(selectedNode.id, { [field]: value });
  // };

  // const handleInputChange = (field, value) => {
  //   if (field.startsWith('data.')) {
  //     console.log("inside handler:", field, value)
  //     const nestedField = field.split('.')[1];
  //     const currentInnerData = (selectedNode?.data?.data) || {};
  //     const updatedInnerData = { ...currentInnerData, [nestedField]: value };
  //     // Update only the nested `data` object while preserving other node.data fields
  //     updateNodeProperties(selectedNode.id, { data: updatedInnerData });
  //   } else {
  //     // Handle top-level fields on node.data (e.g., name, description, stage_name)
  //     updateNodeProperties(selectedNode.id, { [field]: value });
  //   }
  //   if (field === 'agent_code') {
  //     setMCPToolsBasisOnAgent(value);
  //   }
  // };

  const handleInputChange = (field, value) => {
  if (field.startsWith('data.')) {
    console.log("inside handler:", field, value);
    const nestedField = field.split('.')[1];

    updateNodeProperties(selectedNode.id, { 
      data: { [nestedField]: value } 
    });
  } else {

    updateNodeProperties(selectedNode.id, { [field]: value });
  }

  if (field === 'agent_code') {
    setMCPToolsBasisOnAgent(value);
  }
};


  const setMCPToolsBasisOnAgent = (agentCd) => {
    const selectedAgent = agentList.find(agent => agent.code == agentCd);
    selectedAgent?.mcp_servers && setLocalMCPServerData((prev) => {
      if (!selectedAgent?.mcp_servers) return { mcp_servers: {} }
      const data = { mcp_servers: { ...prev.mcp_servers, ...selectedAgent?.mcp_servers } }
      return data;
    })
  }

  const renderAgentProperties = () => {
    const { agent_code, persona, capabilities = [] } = selectedNode.data;

    const currentQueryBlock = selectedNode?.data?.data?.query_code_block || { lang: 'python', code_block: '' };
    const currentOutputSchema = selectedNode?.data?.data?.output_schema || { source: 'example', sample_example: '' };

    const handleAgentQueryCodeChange = (val) => {
      const updated = {
        lang: currentQueryBlock.lang || 'python',
        code_block: val || '',
      };
      handleInputChange('data.query_code_block', updated);
    };

    const handleAgentOutputSourceChange = (value) => {
      const updated = {
        ...currentOutputSchema,
        source: value || 'example',
      };
      handleInputChange('data.output_schema', updated);
    };

    const handleAgentSampleExampleChange = (value) => {
      const updated = {
        ...currentOutputSchema,
        source: currentOutputSchema.source || 'example',
        sample_example: value,
      };
      handleInputChange('data.output_schema', updated);
    };

    return (
      <>
        <FormGroup>
          <Label htmlFor="agent-type">Agent Type</Label>
          <Select
            id="agent-type"
            value={selectedNode.data.agent_code}
            onChange={(e) => handleInputChange('agent_code', e.target.value)} >
            <option value="">Select Agent</option>
            {agentList?.length && agentList?.map((agent, index) => (
              <option key={index} value={agent.code}>{agent.name}</option>
            ))}
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>MCP Server</Label>
          {!isVisisbleMCPTools && (!selectedNode?.data?.mcp_servers) && <TagsContainer>
            <AddTagButton onClick={() => { setIsVisibleMCPTools(true) }}>+ Add</AddTagButton>
          </TagsContainer>}
        </FormGroup>

        {
          Boolean(isVisisbleMCPTools ||
            (selectedNode?.data?.mcp_servers &&
              Object.keys(selectedNode?.data?.mcp_servers).length)) &&
          (() => {
            const selectedForThisServer =
              selectedNode?.data?.mcp_servers?.[selectedMCPServer] || [];
            const serverList = mcpToolsData?.server_indexed_mcp_tools && Object.keys(
              mcpToolsData.server_indexed_mcp_tools
            ) || [];


            const tools =
              mcpToolsData?.server_indexed_mcp_tools[selectedMCPServer];

            return (
              <>
                <Select
                  value={selectedMCPServer}
                  onChange={(e) => setSelectedMCPServer(e.target.value)}
                >
                  {serverList?.map((server, index) => (
                    <option key={index}>{server}</option>
                  ))}
                </Select>

                <Label style={{ marginTop: '5px' }}>MCP Server Tools</Label>
                <MultiSelectDropdownSearch
                  options={tools}
                  selected={selectedForThisServer}
                  onChange={(newSelectedTools) => {
                    setLocalMCPServerData((prev) => {
                      const data = {
                        ...prev,
                        mcp_servers: {
                          ...(prev.mcp_servers || {}),
                          [selectedMCPServer]: newSelectedTools,
                        },
                      }
                      return data
                    });
                  }}
                  placeholder={`Select tools for ${selectedMCPServer}`}
                  displayKey="name"
                  valueKey="name"
                />
              </>
            );
          })()}

        <FormGroup>
          <Label htmlFor="agent-persona">Persona</Label>
          <Select
            id="agent-persona"
            value={persona || ''}
            onChange={(e) => handleInputChange('persona', e.target.value)}>
            <option value="">Select Persona</option>
            {personaList?.map((persona, index) => (
              <option key={index} value={persona.code}>
                {persona.name}
              </option>
            ))}
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>Capabilities</Label>
          <TagsContainer>
            {capabilities?.map((capability, index) => (
              <Tag key={index}>
                {capability}
                <RemoveTag onClick={() => {
                  const newCapabilities = [...capabilities];
                  newCapabilities.splice(index, 1);
                  handleInputChange('capabilities', newCapabilities);
                }}>✕</RemoveTag>
              </Tag>
            ))}
            <AddTagButton onClick={() => {
              const newCapability = prompt('Enter capability:');
              if (newCapability && !capabilities.includes(newCapability)) {
                handleInputChange('capabilities', [...capabilities, newCapability]);
              }
            }}>+ Add</AddTagButton>
          </TagsContainer>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="knowledge-type">Prompts</Label>
          <Select
            id="knowledge-check_list"
            value={selectedNode.data.check_list}
            onChange={(e) => handleInputChange('check_list', e.target.value)}
          >
            <option value="">Select</option>
            {promptList?.map((prompt, index) => (
              <option key={index} value={prompt.code}>{prompt.name}</option>
            ))}
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>Query Code (Python)</Label>
          <PythonCodeEditor
            value={currentQueryBlock.code_block || ''}
            onChange={handleAgentQueryCodeChange}
          />
        </FormGroup>

        <FormGroup>
          <Label htmlFor="agent-output-source">Output Schema Source</Label>
          <Select
            id="agent-output-source"
            value={currentOutputSchema.source || 'example'}
            onChange={(e) => handleAgentOutputSourceChange(e.target.value)}
          >
            <option value="example">Example</option>
            <option value="code">Code</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="agent-output-example">Sample Example</Label>
          <Textarea
            id="agent-output-example"
            value={currentOutputSchema.sample_example || ''}
            onChange={(e) => handleAgentSampleExampleChange(e.target.value)}
            placeholder="Enter a sample JSON/output example"
          />
        </FormGroup>
      </>
    );
  };

  const renderModelProperties = () => {
    const { modelType, provider, version } = selectedNode.data;

    return (
      <>
        <FormGroup>
          <Label htmlFor="model-type">Model Type</Label>
          <Select
            id="model-type"
            value={selectedNode.data.data.model_code}
            onChange={(e) => handleInputChange('data.model_code', e.target.value)} >
            <option value="">Select Model</option>
            {modelList?.map((model, index) => (
              <option key={index} value={model.code}>{model.name}</option>
            ))}
          </Select>
        </FormGroup>

        {/* <FormGroup>
          <Label htmlFor="model-version">Version</Label>
          <Input
            id="model-version"
            value={version || ''}
            onChange={(e) => handleInputChange('version', e.target.value)}
            placeholder="e.g. gpt-4, claude-3, etc."
          />
        </FormGroup> */}
      </>
    );
  };

  const renderKnowledgeProperties = () => {
    const { knowledgeType, source } = selectedNode.data;
    return (
      <>
        <FormGroup>
          <Label htmlFor="knowledge-type">Knowledge Base</Label>
          <Select
            id="knowledge-type"
            value={selectedNode.data.data.kb_code}
            onChange={(e) => handleInputChange('data.kb_code', e.target.value)}
          >
            <option value="">Select</option>
            {knowledgeBaseList?.map((kb, index) => (
              <option key={index} value={kb.code}>{kb.name}</option>
            ))}
          </Select>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="knowledge-type">Operation</Label>
          <Select
            id="knowledge-operation"
            value={selectedNode.data.data.operation}
            onChange={(e) => handleInputChange('data.operation', e.target.value)}
          >
            <option value="">Select</option>
            <option value='ingest'>Ingest</option>
            <option value='query'>Query</option>
            <option value='search'>Search</option>
            <option value='report'>Report</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="knowledge-type">Prompts</Label>
          <Select
            id="knowledge-check_list"
            value={selectedNode.data.check_list}
            onChange={(e) => handleInputChange('check_list', e.target.value)}
          >
            <option value="">Select</option>
            {promptList?.map((prompt, index) => (
              <option key={index} value={prompt.code}>{prompt.name}</option>
            ))}
          </Select>
        </FormGroup>

        {/* <FormGroup>
          <Label htmlFor="knowledge-source">Source</Label>
          <Input
            id="knowledge-source"
            value={source || ''}
            onChange={(e) => handleInputChange('source', e.target.value)}
            placeholder="e.g. Claims KB, Policy Database, etc."
          />
        </FormGroup> */}
      </>
    );
  };

  const renderToolProperties = () => {
    const { toolType, endpoint, method } = selectedNode.data;

    return (
      <>
        <FormGroup>
          <Label htmlFor="tool-type">Tool Type</Label>
          <Select
            id="tool-type"
            value={toolType}
            onChange={(e) => handleInputChange('toolType', e.target.value)}
          >
            <option value="api">API</option>
            <option value="code">Code Execution</option>
            <option value="webhook">Webhook</option>
            <option value="function">Function</option>
          </Select>
        </FormGroup>

        {toolType === 'api' || toolType === 'webhook' ? (
          <>
            <FormGroup>
              <Label htmlFor="tool-endpoint">Endpoint</Label>
              <Input
                id="tool-endpoint"
                value={endpoint || ''}
                onChange={(e) => handleInputChange('endpoint', e.target.value)}
                placeholder="e.g. https://api.example.com/v1/data"
              />
            </FormGroup>

            <FormGroup>
              <Label htmlFor="tool-method">Method</Label>
              <Select
                id="tool-method"
                value={method || 'GET'}
                onChange={(e) => handleInputChange('method', e.target.value)}
              >
                <option value="GET">GET</option>
                <option value="POST">POST</option>
                <option value="PUT">PUT</option>
                <option value="DELETE">DELETE</option>
              </Select>
            </FormGroup>
          </>
        ) : toolType === 'code' ? (
          <FormGroup>
            <Label htmlFor="tool-code">
              Code
              <Button type="button" ><FontAwesomeIcon icon={faPlay} /></Button>
            </Label>
            {/* <Textarea
              id="tool-code"
              value={selectedNode.data.data.code_block || ''}
              onChange={(e) => handleInputChange('data.code_block', e.target.value)}
              placeholder="Enter code to execute"
              style={{ minHeight: '120px', fontFamily: 'monospace' }}
            /> */}
            <PythonCodeEditor
              value={selectedNode.data.data.code_block}
              onChange={val => handleInputChange('data.code_block', val)}
            />
          </FormGroup>
        ) : null}
      </>
    );
  };

  const renderApiProperties = () => {
    const apiData = selectedNode?.data?.data || {};
    const { headers, url, token, tokenKey, method, payload = {}, content_type, response_type } = apiData;
    const urlCodeBlock = apiData?.url_from_code_block || { lang: 'python', code_block: '' };
    const requestPayloadBlock =
      typeof apiData?.request_payload === 'string'
        ? { lang: 'python', code_block: apiData.request_payload }
        : apiData?.request_payload || { lang: 'python', code_block: '' };

    const handleHeaderChange = (type, value, index) => {
      const updatedHeaderConfig = headerDataConfig?.map((config, i) => {
        if (i === index) {
          return { ...config, [type]: value };
        }
        return config;
      });
      setHeaderDataConfig(updatedHeaderConfig);
      createAndSetHeaderObject(updatedHeaderConfig);
    };

    const addNewHeader = () => {
      setHeaderDataConfig(prevData => [...prevData, { name: "", value: "" }]);
    }

    const createAndSetHeaderObject = (data) => {
      let headerObjectData = {};
      data.length && data.forEach(item => {
          headerObjectData[item.name] = item.value;
      });
      handleInputChange('data.headers', headerObjectData)
    }

    const handleRemoveHeader = (index) => {
      if (headerDataConfig.length > 1) {
        const updatedHeaderCofig = headerDataConfig.filter((_, idx) => idx !== index);
        setHeaderDataConfig(updatedHeaderCofig);
        createAndSetHeaderObject(updatedHeaderCofig)
      }
    }

    const handlePayloadChange = (e) => {
      const value = e.target.value;
      setPayloadData(value);

      try {
        const parsed = JSON.parse(value);
        handleInputChange("data.payload", parsed);
      } catch (error) {
        console.warn("Invalid JSON:", error.message);
      }
    };

    const handleUrlCodeChange = (val) => {
      const updated = {
        lang: urlCodeBlock.lang || 'python',
        code_block: val || '',
      };
      handleInputChange('data.url_from_code_block', updated);
    };

    const handleRequestPayloadChange = (e) => {
      const code = e.target.value;
      const updated = {
        lang: requestPayloadBlock.lang || 'python',
        code_block: code || '',
      };
      handleInputChange('data.request_payload', updated);
    };

    const syncRequestHeaders = (config) => {
      setRequestHeadersConfig(config);
      const requestHeaders = config
        .filter((h) => (h.key || '').trim() !== '')
        .map((h) => ({
          key: h.key,
          value: {
            lang: h.lang || 'python',
            code_block: h.code || '',
          },
        }));
      handleInputChange('data.request_headers', requestHeaders);
    };

    const handleRequestHeaderKeyChange = (index, value) => {
      const updated = requestHeadersConfig.map((h, i) =>
        i === index ? { ...h, key: value } : h
      );
      syncRequestHeaders(updated);
    };

    const handleRequestHeaderCodeChange = (index, code) => {
      const updated = requestHeadersConfig.map((h, i) =>
        i === index ? { ...h, code } : h
      );
      syncRequestHeaders(updated);
    };

    const handleAddRequestHeader = () => {
      const updated = [
        ...requestHeadersConfig,
        { key: '', lang: 'python', code: '' },
      ];
      syncRequestHeaders(updated);
    };

    const handleRemoveRequestHeader = (index) => {
      if (requestHeadersConfig.length <= 1) return;
      const updated = requestHeadersConfig.filter((_, i) => i !== index);
      syncRequestHeaders(updated);
    };

    const syncResponseHandlers = (config) => {
      setResponseHandlersConfig(config);
      const handlers = config.map((h) => ({
        http_status_code: h?.http_status_code ?? 200,
        response_extraction: {
          lang: h?.lang || 'python',
          code_block: h?.code || '',
        },
      }));
      handleInputChange('data.response_handlers', handlers);
    };

    const handleResponseHandlerStatusChange = (index, value) => {
      const intVal = parseInt(value, 10);
      const updated = responseHandlersConfig.map((h, i) =>
        i === index
          ? { ...h, http_status_code: Number.isNaN(intVal) ? undefined : intVal }
          : h
      );
      syncResponseHandlers(updated);
    };

    const handleResponseHandlerCodeChange = (index, code) => {
      const updated = responseHandlersConfig.map((h, i) =>
        i === index
          ? { ...h, code }
          : h
      );
      syncResponseHandlers(updated);
    };

    const handleAddResponseHandler = () => {
      const updated = [
        ...responseHandlersConfig,
        { http_status_code: 200, lang: 'python', code: 'response = response' },
      ];
      syncResponseHandlers(updated);
    };

    const handleRemoveResponseHandler = (index) => {
      if (responseHandlersConfig.length <= 1) return;
      const updated = responseHandlersConfig.filter((_, i) => i !== index);
      syncResponseHandlers(updated);
    };

    return (
      <>
        <FormGroup>
          <Label htmlFor="tool-endpoint">Endpoint</Label>
          <Input
            id="tool-endpoint"
            value={url || ''}
            onChange={(e) => handleInputChange('data.url', e.target.value)}
            placeholder="e.g. https://api.example.com/v1/data"
          />
        </FormGroup>

        <FormGroup>
          <Label>URL from Code (Python)</Label>
          <PythonCodeEditor
            value={urlCodeBlock.code_block || ''}
            onChange={handleUrlCodeChange}
          />
        </FormGroup>

        <FormGroup>
          <Label>Request Headers</Label>
          {requestHeadersConfig.map((header, index) => (
            <div
              key={index}
              style={{
                marginBottom: '12px',
                border: '1px solid #eee',
                padding: '8px',
                borderRadius: '4px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '6px',
                }}
              >
                <Input
                  id={`api-request-header-key-${index}`}
                  value={header.key || ''}
                  onChange={(e) => handleRequestHeaderKeyChange(index, e.target.value)}
                  placeholder="Header key (e.g. Authorization)"
                  style={{ maxWidth: '260px' }}
                />
                <TrashSection onClick={() => handleRemoveRequestHeader(index)}>
                  <FaTrash size={18} />
                </TrashSection>
              </div>

              <div>
                <Label>Value (Python)</Label>
                <PythonCodeEditor
                  value={header.code || ''}
                  onChange={(code) => handleRequestHeaderCodeChange(index, code)}
                />
              </div>
            </div>
          ))}
          <AddTagButton type="button" onClick={handleAddRequestHeader}>
            + Add Request Header
          </AddTagButton>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="tool-header">Headers</Label>
          {
            headerDataConfig.length > 0 && headerDataConfig?.map((config, index) => (
              <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', marginBottom: '8px' }}>
                <Input
                  id="tool-header"
                  value={config.name || ''}
                  onChange={(e) => handleHeaderChange("name", e.target.value, index)}
                  placeholder="name"
                />
                <Input
                  id="tool-header"
                  value={config.value || ''}
                  onChange={(e) => handleHeaderChange("value", e.target.value, index)}
                  placeholder="value"
                />
                <TrashSection onClick={() => handleRemoveHeader(index)}>
                  <FaTrash size={18} />
                </TrashSection>
              </div>
            ))
          }
          <AddTagButton onClick={() => addNewHeader()}>+ Add</AddTagButton>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="tool-token">Token</Label>
          <Input
            id="tool-token"
            value={token || ''}
            onChange={(e) => handleInputChange('data.token', e.target.value)}
            placeholder="e.g. Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJib..."
          />
        </FormGroup>

        <FormGroup>
          <Label htmlFor="tool-method">Method</Label>
          <Select
            id="tool-method"
            value={method}
            onChange={(e) => {
              handleInputChange('data.method', e.target.value)
              if (e.target.value == "GET") {
                handleInputChange('data.payload', "payloadStr")
              }
            }}
          >
            <option value="">Select</option>
            <option value="GET">GET</option>
            <option value="POST">POST</option>
            <option value="PUT">PUT</option>
            <option value="DELETE">DELETE</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="api-content-type">Content Type</Label>
          <Input
            id="api-content-type"
            value={content_type || 'application/json'}
            onChange={(e) => handleInputChange('data.content_type', e.target.value)}
            placeholder="e.g. application/json"
          />
        </FormGroup>

        <FormGroup>
          <Label htmlFor="api-response-type">Response Type</Label>
          <Select
            id="api-response-type"
            value={response_type || 'json'}
            onChange={(e) => handleInputChange('data.response_type', e.target.value)}
          >
            <option value="json">JSON</option>
            <option value="text">Text</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="api-request-payload">Request Payload Template</Label>
          <Textarea
            id="api-request-payload"
            value={requestPayloadBlock.code_block || ''}
            onChange={handleRequestPayloadChange}
            placeholder="e.g. payload = request"
          />
        </FormGroup>

        {(method !== 'GET') && (
          <FormGroup>
            <Label htmlFor="tool-payload">Payload (JSON)</Label>
            <Textarea
              id="tool-payload"
              value={payloadData || ''}
              onChange={(e) => handlePayloadChange(e)}
              placeholder=""
            />
          </FormGroup>
        )}

        <FormGroup>
          <Label>Response Handlers</Label>
          {responseHandlersConfig.map((handler, index) => (
            <div
              key={index}
              style={{
                marginBottom: '12px',
                border: '1px solid #eee',
                padding: '8px',
                borderRadius: '4px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '6px',
                }}
              >
                <Label htmlFor={`api-status-${index}`} style={{ marginBottom: 0 }}>
                  HTTP Status
                </Label>
                <Input
                  id={`api-status-${index}`}
                  type="number"
                  value={handler.http_status_code ?? 200}
                  onChange={(e) => handleResponseHandlerStatusChange(index, e.target.value)}
                  style={{ maxWidth: '100px' }}
                />
                <TrashSection onClick={() => handleRemoveResponseHandler(index)}>
                  <FaTrash size={18} />
                </TrashSection>
              </div>

              <div>
                <Label>Response Extraction (Python)</Label>
                <PythonCodeEditor
                  value={handler.code || ''}
                  onChange={(code) => handleResponseHandlerCodeChange(index, code)}
                />
              </div>
            </div>
          ))}

          <AddTagButton type="button" onClick={handleAddResponseHandler}>
            + Add Handler
          </AddTagButton>
        </FormGroup>

      </>
    );
  };

  const renderEmailOutProperties = () => {
    const { toolType, endpoint, method } = selectedNode.data;

   
  };

  const renderCodeProperties = () => {
    const { toolType, endpoint, method } = selectedNode.data;

    return (
      <>
        <FormGroup>
          <Label htmlFor="tool-code">
            Code
            <Button type="button" onClick={handleOpenEvalModal}><FontAwesomeIcon icon={faPlay} /></Button>
          </Label>
          {/* <Textarea
            id="tool-code"
            value={selectedNode.data.data.code_block || ''}
            onChange={(e) => handleInputChange('data.code_block', e.target.value)}
            placeholder="Enter code to execute"
            style={{ minHeight: '120px', fontFamily: 'monospace' }}
          /> */}
          <PythonCodeEditor
            value={selectedNode.data.data.code_block}
            onChange={val => handleInputChange('data.code_block', val)}
          />
        </FormGroup>

      </>
    );
  };

  const renderClassifierProperties = () => {
    const { toolType, endpoint, method } = selectedNode.data;

    return (
      <>
        <FormGroup>
          <Label htmlFor="classes_knowledge_base">Classifier</Label>
          <Select
            id="classes_knowledge_base"
            value={selectedNode.data.data.classes_knowledge_base}
            onChange={(e) => handleInputChange('data.classes_knowledge_base', e.target.value)} >
            <option value="">Select Agent</option>
            {knowledgeBaseList?.map((kb, index) => (
              <option key={index} value={kb.code}>{kb.name}</option>
            ))}
          </Select>
        </FormGroup>
        <FormGroup>
          <Label htmlFor="classes_query">Class Query</Label>
          {/* <Input
            id="classes_queryt"
            value={selectedNode.data.data.classes_query || ''}
            onChange={(e) => handleInputChange('data.classes_query', e.target.value)}
            placeholder=""
          /> */}
          <Textarea
            id="classes_query"
            value={selectedNode.data.data.classes_query || ''}
            onChange={(e) => handleInputChange('data.classes_query', e.target.value)}
            style={{ minHeight: '120px' }}
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="query_suffix">Query SUffix</Label>
          <Textarea
            id="query_suffix"
            value={selectedNode.data.data.query_suffix || ''}
            onChange={(e) => handleInputChange('data.query_suffix', e.target.value)}
            style={{ minHeight: '120px' }}
          />
        </FormGroup>
      </>
    );
  };

  const renderTriggerProperties = () => {
    const { triggerType, schedule } = selectedNode.data;

    return (
      <>
        <FormGroup>
          <Label htmlFor="trigger-type">Trigger Type</Label>
          <Select
            id="trigger-type"
            value={triggerType}
            onChange={(e) => handleInputChange('triggerType', e.target.value)}
          >
            <option value="manual">Manual</option>
            <option value="scheduled">Scheduled</option>
            <option value="event">Event-based</option>
            <option value="webhook">Webhook</option>
          </Select>
        </FormGroup>

        {triggerType === 'scheduled' && (
          <FormGroup>
            <Label htmlFor="trigger-schedule">Schedule (cron)</Label>
            <Input
              id="trigger-schedule"
              value={schedule || ''}
              onChange={(e) => handleInputChange('schedule', e.target.value)}
              placeholder="e.g. 0 9 * * 1-5"
            />
          </FormGroup>
        )}
      </>
    );
  };

  const renderOutputProperties = () => {
    const { outputType, format, destination } = selectedNode.data;

    return (
      <>
        <FormGroup>
          <Label htmlFor="output-type">Output Type</Label>
          <Select
            id="output-type"
            value={outputType}
            onChange={(e) => handleInputChange('outputType', e.target.value)}
          >
            <option value="response">Response</option>
            <option value="file">File</option>
            <option value="database">Database</option>
            <option value="webhook">Webhook</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="output-format">Format</Label>
          <Select
            id="output-format"
            value={format || 'json'}
            onChange={(e) => handleInputChange('format', e.target.value)}
          >
            <option value="json">JSON</option>
            <option value="xml">XML</option>
            <option value="csv">CSV</option>
            <option value="text">Plain Text</option>
          </Select>
        </FormGroup>

        {outputType !== 'response' && (
          <FormGroup>
            <Label htmlFor="output-destination">Destination</Label>
            <Input
              id="output-destination"
              value={destination || ''}
              onChange={(e) => handleInputChange('destination', e.target.value)}
              placeholder={outputType === 'file' ? 'e.g. /path/to/file.json' :
                outputType === 'database' ? 'e.g. claims_db.results' :
                  'e.g. https://webhook.example.com/callback'}
            />
          </FormGroup>
        )}
      </>
    );
  };

  const renderNodeSpecificProperties = () => {
    switch (selectedNode.type) {
      case 'agentNode':
        return renderAgentProperties();
      case 'modelNode':
        return renderModelProperties();
      case 'knowledgeNode':
        return renderKnowledgeProperties();
      case 'toolNode':
        return renderToolProperties();
      case 'triggerNode':
        return renderTriggerProperties();
      case 'emailOutNode':
        return <EmailNode
                 selectedNode={selectedNode}
                  handleInputChange={handleInputChange}
                  />;
      case 'documentNode':
        return <DocumentNodeConfig
                  selectedNode={selectedNode}
                  handleInputChange={handleInputChange}
                />;
      case 'fileNode':
        return <FileNodeConfig
                  selectedNode={selectedNode}
                  handleInputChange={handleInputChange}
                />;
      case 'plannerNode':
        return (
          <PlannerNodeConfig
            selectedNode={selectedNode}
            handleInputChange={handleInputChange}
          />
        );
      case 'entityOperationNode':
        return (
          <EntityOperationNodeConfig
            selectedNode={selectedNode}
            handleInputChange={handleInputChange}
          />
        );
      case 'apiNode':
        return renderApiProperties();
      case 'taskServiceNode': 
      return <TaskNode
                  selectedNode={selectedNode}
                  handleInputChange={handleInputChange} 
                  selectedPipeline={selectedPipeline}
                />;
      case 'manualTaskNode':
        return (
          <ManualTaskNodeConfig
            selectedNode={selectedNode}
            handleInputChange={handleInputChange}
          />
        );
      case 'timerNode' :
        return <TimerNode 
                selectedNode={selectedNode}
                handleInputChange={handleInputChange} 
                  />
      case 'codeNode':
        return renderCodeProperties();
      case 'classifierNode':
        return renderClassifierProperties();
      case 'outputNode':
        return renderOutputProperties();
      default:
        return null;
    }
  };

  // Helper to extract workflow_vars from code block (simple regex for demo)
  const extractWorkflowVars = (code) => {
    // Example: look for workflow_vars['varName'] or workflow_vars["varName"]
    const regex = /workflow_vars\[['"](\w+)['"]\]/g;
    const vars = {};
    let match;
    while ((match = regex.exec(code))) {
      vars[match[1]] = '';
    }
    return vars;
  };

  // Fetch last successful run workflow_vars
  const fetchLastRunVars = async () => {
    const nodeCode = selectedNode.id;
    if (!nodeCode) return;
    const filters = {
      transaction_status: 'CLOSED',
      code: nodeCode
    };
    const sort = { "created_at": "desc" };
    const results = await getNodesForPipeline(filters, sort);

    return results;

    // if (results && results.length > 0) {
    //   const node = results[0];
    //   setLastRunVars(node.workflow_vars || {});
    //   setWorkflowVars(node.workflow_vars || {});
    // }
  };

  // Open modal and initialize workflow vars
  const handleOpenEvalModal = async () => {
    setShowEvalModal(true);
    setWorkflowVarsMode('manual');
    setEvalResult(null);
    setLastRunVars(null);
    // Extract workflow vars from code
    const code = selectedNode?.data?.data?.code_block || '';
    setWorkflowVars(extractWorkflowVars(code));
  };

  // Handle mode change
  const handleWorkflowVarsModeChange = async (mode) => {
    setWorkflowVarsMode(mode);
    if (mode === 'lastRun') {
      const resp = await fetchLastRunVars();
      if (resp.length) {
        const result = extractWorkflowVarsForLastRun(resp[0]?.workflow_vars);
        setWorkflowVars(result)
      }
    } else {
      // Reset to extracted
      const code = selectedNode?.data?.data?.code_block || '';
      setWorkflowVars(extractWorkflowVars(code));
    }
  };

  const extractWorkflowVarsForLastRun = (obj) => {
    const result = {};

    for (const key in obj) {
      const value = obj[key];

      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        result[key] = JSON.stringify(value);
      } else {
        result[key] = value;
      }
    }

    return result;
  }


  // Handle workflow var change
  const handleWorkflowVarChange = (key, value) => {
    setWorkflowVars((prev) => ({ ...prev, [key]: value }));
  };

  // Evaluate code block
  const handleEvaluate = async () => {
    setIsEvaluating(true);
    setEvalResult(null);
    try {
      const codeBlock = selectedNode?.data?.data?.code_block || '';
      const payload = {
        code_block: [codeBlock],
        request: {},
        workflow_vars: workflowVars,
        verify_bool: false,
      };
      const res = await evaluateNodeExpression(payload);
      setEvalResult(res.data || res);
    } catch (err) {
      setEvalResult({ error: err.message });
    } finally {
      setIsEvaluating(false);
    }
  };

  return (
    <PanelContainer>
      <PanelTitle>Properties</PanelTitle>
      <div style={{ paddingBottom: '1rem', height: 'calc(100dvh - 228px)', overflowY: 'auto' }}>
        <NodeHeader>
          <NodeTypeIcon
            background={nodeTypeInfo.background}
            color={nodeTypeInfo.color}
          >
            <FontAwesomeIcon icon={nodeTypeInfo.icon} />
          </NodeTypeIcon>
          <NodeInfo>
            {/* <NodeType>{nodeTypeInfo.label}</NodeType> */}
            <NodeName>{nodeTypeInfo.label}</NodeName>
            {/* <NodeName>{selectedNode.data.label}</NodeName> */}
          </NodeInfo>
        </NodeHeader>

        <SectionTitle>Basic Properties</SectionTitle>
    {console.log(selectedNode)}
        <FormGroup>
          <Label htmlFor="node-label">Label</Label>
          <Input
            id="node-label"
            value={selectedNode.data.name || ''}
            onChange={(e) => handleInputChange('name', e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label htmlFor="node-description">Description</Label>
          <Textarea
            id="node-description"
            value={selectedNode.data.description || ''}
            onChange={(e) => handleInputChange('description', e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label htmlFor="node-stage-name">Stage Name</Label>
          <Input
            id="node-stage-name"
            value={selectedNode.data.stage_name || ''}
            onChange={(e) => handleInputChange('stage_name', e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label htmlFor="node-stage-description">Stage Description</Label>
          <Textarea
            id="node-stage-description"
            value={selectedNode.data.stage_description || ''}
            onChange={(e) => handleInputChange('stage_description', e.target.value)}
          />
        </FormGroup>

        <SectionTitle>Specific Properties</SectionTitle>

        {renderNodeSpecificProperties()}
      </div>
      {/* <PipelineSection>
        <SectionTitle>Pipeline Properties</SectionTitle>

        <FormGroup>
          <Label htmlFor="pipeline-description">Description</Label>
          <Textarea
            id="pipeline-description"
            value={pipelineDescription}
            onChange={(e) => setPipelineDescription(e.target.value)}
            placeholder="Describe the purpose of this pipeline"
          />
        </FormGroup>
      </PipelineSection> */}
      {/* EVALUATION MODAL */}
      {showEvalModal && (
        <>
          <Modal isOpen={showEvalModal} onClose={() => setShowEvalModal(false)} size="large">

            <div className='evalModal' style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
              {/* Section 1: Workflow Variables */}
              <div>
                <h3>Workflow Variables</h3>
                <div style={{ marginBottom: 8 }}>
                  <label>
                    <input
                      type="radio"
                      checked={workflowVarsMode === 'manual'}
                      onChange={() => handleWorkflowVarsModeChange('manual')}
                    />{' '}
                    Manual
                  </label>
                  <label style={{ marginLeft: 16 }}>
                    <input
                      type="radio"
                      checked={workflowVarsMode === 'lastRun'}
                      onChange={() => handleWorkflowVarsModeChange('lastRun')}
                    />{' '}
                    Use Last Successful Run
                  </label>
                </div>
                <div>
                  {Object.keys(workflowVars).length === 0 && <div style={{ color: '#888' }}>No workflow variables found.</div>}
                  {Object.keys(workflowVars).map((key) => (
                    <div key={key} style={{ marginBottom: 8 }}>
                      <label style={{ marginRight: 8 }}>{key}:</label>
                      {key !== 'ingestion_request' ? <Textarea
                        style={{ width: '100%', fontFamily: 'monospace' }}
                        type="text"
                        value={workflowVars[key]}
                        onChange={e => handleWorkflowVarChange(key, e.target.value)}
                        disabled={workflowVarsMode === 'lastRun'}
                      /> : <pre style={{
                        background: '#f6f6f6',
                        padding: 12,
                        borderRadius: 4,
                        minHeight: 80,
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word'
                      }}>
                        {workflowVars[key] ? JSON.stringify(JSON.parse(workflowVars[key]), null, 2) : 'No result yet.'}
                      </pre>}
                    </div>
                  ))}
                </div>
              </div>
              {/* Section 2: Code Block */}
              <div>
                <h3>Code Block</h3>
                <PythonCodeEditor
                  value={selectedNode?.data?.data?.code_block || ''}
                  onChange={() => { }}
                  readOnly
                />
                <Button onClick={handleEvaluate} disabled={isEvaluating} style={{ marginTop: 12 }}>
                  {isEvaluating ? 'Evaluating...' : 'Play'}
                </Button>
              </div>
              {/* Section 3: Result */}
              <div>
                <h3>Result</h3>
                <pre style={{
                  background: '#f6f6f6',
                  padding: 12,
                  borderRadius: 4,
                  minHeight: 80,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word'
                }}>
                  {evalResult ? JSON.stringify(evalResult, null, 2) : 'No result yet.'}
                </pre>
              </div>
            </div>
          </Modal>
        </>
      )}
    </PanelContainer>
  );
};

export default PropertiesPanel;
